var _polygon, _polygon2, _polygon3, _path, _polygon4, _polygon5, _polygon6, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-210"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.03,
    y: 76.08,
    width: 48.88,
    height: 48.88,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.49,73.54v54h54v-54ZM112.91,125H64V76.08h48.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.89,
    y: 88,
    width: 16.9,
    height: 38.1,
    transform: "translate(197.39 16.7) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.71,
    y: 90.76,
    width: 19.52,
    height: 19.52,
    transform: "translate(188.99 12.05) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.45,
    y: 73.54,
    width: 2.08,
    height: 53.97,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.99,
    y: 76.08,
    width: 48.88,
    height: 48.88,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.39,
    y: 83.9,
    width: 12.76,
    height: 36.87,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.45,73.54v54h54v-54ZM185.87,125H137V76.08h48.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.67,
    y: 90.76,
    width: 19.52,
    height: 19.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.42,
    y: 73.54,
    width: 2.08,
    height: 53.97,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.95,
    y: 76.08,
    width: 48.88,
    height: 48.88,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.38,
    y: 82.74,
    width: 26.82,
    height: 16.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.41,73.54v54h54v-54ZM258.83,125H210V76.08h48.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.63,
    y: 90.76,
    width: 19.52,
    height: 19.52,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.38,
    y: 73.54,
    width: 2.08,
    height: 53.97,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.59,325.25l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.17h.28v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.82,339.36l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05H55.9v-.45l-.06-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.26,166.53l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.05h-.44v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.49,180.64l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.05h-.45v-.45l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.42.05-8.83.16-13.24.16L210,170l.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.77,166.53l-13.12.28-6.66.11c-2.23,0-4.46,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.19,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.66,339.36l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.05h-.45v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.17h.27v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.89,56.92l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69,0H402v-.44l0-11.19v-.51h.51l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.12-3.7-.14-5.53l.28.27c-4.42,0-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.35,0,6.54.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.66,71l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69,0h-.45V71l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.06.5-.49L417.62,71l-.44-.45c2.18,0,4.36,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.82,56.92l-13.12.27L63,57.31c-2.23,0-4.47,0-6.7,0H55.9v-.44l-.06-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,110.7a3.93,3.93,0,1,1-3.13-4.6A3.94,3.94,0,0,1,283.89,110.7Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.77,
    y: 90.76,
    width: 3.01,
    height: 19.8,
    transform: "translate(23.81 -51.34) rotate(10.77)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.49,107.46a3.94,3.94,0,1,1-3.14-4.61A3.94,3.94,0,0,1,297.49,107.46Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.36,
    y: 87.51,
    width: 3.01,
    height: 19.8,
    transform: "translate(23.44 -53.93) rotate(10.77)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.19 88.01 284.15 93.25 284.65 90.65 301.68 85.41 301.19 88.01",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.26 92.91 283.22 98.15 283.71 95.55 300.75 90.31 300.26 92.91",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18,170.11a2.19,2.19,0,1,1-1.75-2.57A2.2,2.2,0,0,1,276.18,170.11Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.55,
    y: 159,
    width: 1.67,
    height: 11.02,
    transform: "translate(35.58 -48.72) rotate(10.76)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.74,168.3a2.19,2.19,0,1,1-1.74-2.57A2.18,2.18,0,0,1,283.74,168.3Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.12,
    y: 157.19,
    width: 1.67,
    height: 11.02,
    transform: "translate(35.39 -50.17) rotate(10.77)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.81 157.47 276.32 160.39 276.6 158.94 286.08 156.02 285.81 157.47",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.88,154a3.94,3.94,0,1,1-3.14-4.61A3.94,3.94,0,0,1,261.88,154Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.75,
    y: 134.08,
    width: 3.01,
    height: 19.8,
    transform: "translate(31.52 -46.46) rotate(10.77)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.06,
    y: 131.11,
    width: 3.01,
    height: 5.72,
    transform: "translate(29.86 -48.94) rotate(10.77)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.43 132.19 262.13 136.57 262.63 133.97 276.93 129.59 276.43 132.19",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.5 137.09 261.2 141.47 261.7 138.88 275.99 134.49 275.5 137.09",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-210"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 317.21,
    cy: 446.25,
    rx: 104.42,
    ry: 11.41,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-210"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.49 404.55 100.37 404.3 150.25 404.22 250 404.05 349.75 404.21 399.63 404.3 449.5 404.55 399.63 404.79 349.75 404.88 250 405.05 150.25 404.88 100.37 404.79 50.49 404.55",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-210"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.5,
    y: 46.56,
    width: 138.72,
    height: 176.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.02,
    y: 53.64,
    width: 58.63,
    height: 78.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.06,
    y: 53.64,
    width: 58.63,
    height: 78.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.02,
    y: 137.67,
    width: 58.63,
    height: 78.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.06,
    y: 137.67,
    width: 58.63,
    height: 78.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.84,196.05l-1.43-2c-.06-.09.26-.64.16-.76s-1.42.42-1.28.68.53.19.58.26,1,2.31,1,2.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.44,193.36a2.85,2.85,0,0,1-1.08.53",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.84,196.05l-1.43-2c-.06-.09.26-.64.16-.76s-1.42.42-1.28.68.53.19.58.26,1,2.31,1,2.31Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.17,196.12s.37-2.29.38-2.4.64-.27.65-.43-1.3-.7-1.38-.42.23.51.21.6-.93,2.32-.93,2.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08,193.23a2.89,2.89,0,0,1-1.14-.38",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.17,196.12s.37-2.29.38-2.4.64-.27.65-.43-1.3-.7-1.38-.42.23.51.21.6-.93,2.32-.93,2.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.47,198.54l2-1.43c.09-.07.64.25.76.15s-.42-1.42-.68-1.28-.2.53-.27.58-2.31,1-2.31,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.16,197.13a2.71,2.71,0,0,1-.53-1.07",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.47,198.54l2-1.43c.09-.07.64.25.76.15s-.42-1.42-.68-1.28-.2.53-.27.58-2.31,1-2.31,1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.39,201.87l2.41.38c.1,0,.27.63.43.64s.7-1.29.42-1.38-.52.24-.6.22-2.33-.94-2.33-.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.28,202.77a2.73,2.73,0,0,1,.39-1.13",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.39,201.87l2.41.38c.1,0,.27.63.43.64s.7-1.29.42-1.38-.52.24-.6.22-2.33-.94-2.33-.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,204.17l1.43,2c.07.09-.25.64-.15.77s1.42-.42,1.28-.68S401,206,401,206s-1-2.31-1-2.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.39,206.85a2.86,2.86,0,0,1,1.07-.53",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,204.17l1.43,2c.07.09-.25.64-.15.77s1.42-.42,1.28-.68S401,206,401,206s-1-2.31-1-2.31Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.65,204.09s-.36,2.29-.38,2.4-.63.27-.65.43,1.3.71,1.39.42-.24-.51-.22-.6.94-2.32.94-2.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.74,207a2.76,2.76,0,0,1,1.14.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.65,204.09s-.36,2.29-.38,2.4-.63.27-.65.43,1.3.71,1.39.42-.24-.51-.22-.6.94-2.32.94-2.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.35,201.68s-1.88,1.36-2,1.43-.65-.26-.77-.16.42,1.42.68,1.28.2-.53.27-.58,2.31-1,2.31-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.67,203.08a2.85,2.85,0,0,1,.53,1.08",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.35,201.68s-1.88,1.36-2,1.43-.65-.26-.77-.16.42,1.42.68,1.28.2-.53.27-.58,2.31-1,2.31-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.43,198.35,391,198c-.11,0-.27-.64-.43-.65s-.71,1.3-.43,1.38.52-.23.6-.22,2.33.94,2.33.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.54,197.44a2.8,2.8,0,0,1-.39,1.14",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.43,198.35,391,198c-.11,0-.27-.64-.43-.65s-.71,1.3-.43,1.38.52-.23.6-.22,2.33.94,2.33.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.34,195.69s-1.45-2.89-1.51-3,.33-.61.25-.75-1.47.25-1.36.53.51.26.55.34,1,3.27,1,3.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,192a2.85,2.85,0,0,1-1.14.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.72,196.28l1-3.17c0-.11.66-.2.7-.36s-1.21-.86-1.33-.59.17.55.14.63-1.59,3-1.59,3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.34,192.68a2.81,2.81,0,0,1-1.08-.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.69,199.09l3-1.51c.09-.05.61.33.74.24s-.25-1.46-.52-1.35-.27.5-.34.54-3.27,1-3.27,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.38,197.69a2.79,2.79,0,0,1-.4-1.14",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.09,202.46l3.18,1c.1,0,.19.66.35.69s.86-1.21.59-1.33-.55.18-.63.15-3-1.59-3-1.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.69,204.09a2.82,2.82,0,0,1,.52-1.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.28,204.43l1.51,3c.06.1-.33.61-.24.75s1.46-.25,1.36-.53-.51-.26-.55-.34-1-3.27-1-3.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,208.13a2.85,2.85,0,0,1,1.14-.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.91,203.84l-1,3.17c0,.11-.67.2-.7.35s1.21.86,1.33.59-.17-.54-.15-.62,1.59-3,1.59-3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.28,207.44a2.82,2.82,0,0,1,1.09.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,201l-3,1.51c-.1.05-.61-.33-.74-.25s.25,1.47.52,1.36.26-.51.34-.54,3.27-1,3.27-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.25,202.43a2.79,2.79,0,0,1,.4,1.13",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.54,197.65l-3.18-1c-.11,0-.2-.66-.35-.7s-.86,1.22-.59,1.34.54-.18.62-.15,3,1.59,3,1.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.94,196a2.91,2.91,0,0,1-.53,1.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,201.29a5.45,5.45,0,0,0,6.5,4.26,5.64,5.64,0,1,0-2.58-11,5.31,5.31,0,0,0-1.91.86A5.7,5.7,0,0,0,392,201.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,201.29a5.45,5.45,0,0,0,6.5,4.26,5.59,5.59,0,0,0,4.1-3.22c-1.31,1-4,2.7-6.74,1.41-3.76-1.78-3.5-6.08-1.85-8.32A5.7,5.7,0,0,0,392,201.29Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.9,196h1.28s0-.05,0-.14c-.08-.52-.35-2.28-.37-2.38s.6-.51.56-.69-.35-.15-.72-.18-.93,0-.93.18.43.48.44.58S396.9,196,396.9,196Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.2,192.76a3.29,3.29,0,0,1-1.36,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.16,195.85c-.08-.52-.35-2.28-.37-2.38s.6-.51.56-.69-.35-.15-.72-.18a.84.84,0,0,1,.34.15s0,0,0,0,0,.09,0,.14-.4.29-.41.43S398.13,195.78,398.16,195.85Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,196.69l.91.91,0,0h0l1.47-2c.08-.09.79.07.89-.08s-.4-.73-.78-1c-.17-.14-.32-.21-.39-.14s0,.65-.1.72S400,196.69,400,196.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.18,195.32a3.14,3.14,0,0,1-.94-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.91,197.54l1.47-2c.08-.09.79.07.89-.08s-.4-.73-.78-1a2.24,2.24,0,0,1,.35.54.35.35,0,0,1,0,.13c0,.06,0,.1,0,.11s-.46-.07-.6,0A26,26,0,0,0,400.91,197.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.64,199.35v1.28h0l2.52-.39c.12,0,.51.6.68.56a2.12,2.12,0,0,0,.07-1.62.08.08,0,0,0-.07,0c-.2,0-.48.43-.57.43S401.64,199.35,401.64,199.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.88,200.65a3.11,3.11,0,0,1,0-1.36Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.65,200.63l2.52-.39c.12,0,.51.6.68.56a2.12,2.12,0,0,0,.07-1.62,1.19,1.19,0,0,1,0,1,.54.54,0,0,1-.06.11c0,.05-.07.08-.1.07s-.37-.33-.57-.31S401.78,200.59,401.65,200.63Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.1,204.84c.08,0,0,.44,0,.69a.24.24,0,0,0,.06.19c.15.1,1.4-.93,1.17-1.17s-.65,0-.72-.1-.72-.84-1.19-1.41h0l-.5-.61-.91.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.31,205.63a3.21,3.21,0,0,1,1-.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.13,205.53a.24.24,0,0,0,.06.19c.15.1,1.4-.93,1.17-1.17s-.65,0-.72-.1-.72-.84-1.19-1.41a12.39,12.39,0,0,0,1,1.59c.11.06.43.06.46.21a.17.17,0,0,1,0,.11,1.76,1.76,0,0,1-.24.32,2.06,2.06,0,0,1-.31.29l0,0c-.06,0-.11.06-.14,0A.2.2,0,0,1,402.13,205.53Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,207.31s.11.08.26.11c.46.11,1.39.14,1.39-.11s-.43-.49-.44-.58.12-1.35.19-2.09h0c0-.32.06-.55.06-.55H397s.36,2.41.38,2.53S396.79,207.13,396.83,207.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,207.33a3.16,3.16,0,0,1,1.37,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.09,207.42c.46.11,1.39.14,1.39-.11s-.43-.49-.44-.58.12-1.35.19-2.09c-.14.69-.4,2-.39,2.09s.35.42.26.54l0,0-.19.06A4,4,0,0,1,397.09,207.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.34,205.33c.28.32.62.6.75.48s0-.65.1-.72,1.5-1.27,1.92-1.6h0l.11-.09-.9-.91-1.52,2.06c-.07.1-.78-.06-.88.09S392.08,205,392.34,205.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,204.76a3.21,3.21,0,0,1,.94,1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.34,205.33c.28.32.62.6.75.48s0-.65.1-.72,1.5-1.27,1.92-1.6h0A24.49,24.49,0,0,0,393,205c0,.11,0,.57-.12.59a.16.16,0,0,1-.09,0A1.9,1.9,0,0,1,392.34,205.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.33,200.93c.11,0,.24-.12.35-.23a.91.91,0,0,1,.23-.21c.17,0,2.63.25,2.63.25v-1.28l-.52.08h0l-2,.3c-.13,0-.51-.59-.69-.56S390,200.93,390.33,200.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.31,199.43a3.22,3.22,0,0,1-.05,1.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.33,200.93c.11,0,.24-.12.35-.23h-.32a.07.07,0,0,1-.05,0,.2.2,0,0,1,0-.08,1.42,1.42,0,0,1,0-.61,1.89,1.89,0,0,1,.06-.18h0s0-.07.07-.07.46.35.69.32,1.29-.34,1.91-.51l-2,.3c-.13,0-.51-.59-.69-.56S390,200.93,390.33,200.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.83,195.54c.14.14.64,0,.72.1s1.69,2,1.69,2l.9-.9-.19-.15h0l-1.86-1.37c-.1-.07.07-.78-.08-.88s-.45.19-.75.48h0C392,195.12,391.71,195.42,391.83,195.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.87,194.46a3.14,3.14,0,0,1-1,.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.25,194.85a1.2,1.2,0,0,1,.36-.15h.08c.07,0,.13,0,.14.1s-.09.53,0,.64,2,1.15,2.11,1.19l-1.86-1.37c-.1-.07.07-.78-.08-.88S392.55,194.56,392.25,194.85Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.14,203.48c.06.12.26.14.46.05s.32-.27.26-.38-.26-.15-.46-.06S399.09,203.36,399.14,203.48Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.27,203.9a1.3,1.3,0,0,0,.79-.37.43.43,0,0,0,.13-.46c-.09-.21-.29-.21-.48-.23,0,0,0,0,0,0,.33,0,.73.1.66.5s-.67.68-1.09.65C399.24,204,399.23,203.91,399.27,203.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.39,196.66c0,.13.2.27.49.31s.54,0,.56-.17-.2-.26-.49-.3S398.41,196.53,398.39,196.66Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.14,197.24a1,1,0,0,0,.44-.14.32.32,0,0,0,.08-.47,1,1,0,0,0-.71-.38s0,0,0,0c.33,0,.82.18.93.54s-.42.54-.75.54C399.11,197.3,399.11,197.25,399.14,197.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.3,198.31c0,.14.19.24.4.23s.4-.11.39-.25-.18-.23-.4-.22S394.3,198.18,394.3,198.31Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.74,198.84a1.74,1.74,0,0,0,.61-.3c.31-.34-.17-.54-.43-.62,0,0,0,0,0,0,.29,0,.72.2.66.56s-.54.5-.84.45A0,0,0,0,1,394.74,198.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.63,202c0,.11.15.18.32.17s.3-.09.29-.2-.14-.17-.31-.17S400.62,201.9,400.63,202Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,202.4a1.4,1.4,0,0,0,.47-.24c.23-.27-.15-.42-.35-.47,0,0,0,0,0,0,.22,0,.56.14.52.42s-.41.4-.64.37A0,0,0,0,1,401,202.4Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.29,202.13c0,.17.17.33.43.38s.51,0,.54-.21-.17-.33-.43-.37S393.32,202,393.29,202.13Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.25,201.87s0,0,0,0c.25.2.61.51.35.85a.75.75,0,0,1-.95.15s0,0,0,0a1.25,1.25,0,0,0,.69-.09C394.78,202.5,394.49,202.08,394.25,201.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.64,109.89l-1.43-2c-.06-.09.26-.64.16-.76s-1.42.41-1.28.68.53.19.58.26,1,2.31,1,2.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.24,107.21a2.85,2.85,0,0,1-1.08.53",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.64,109.89l-1.43-2c-.06-.09.26-.64.16-.76s-1.42.41-1.28.68.53.19.58.26,1,2.31,1,2.31Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,110s.37-2.29.38-2.4.64-.27.65-.43-1.3-.7-1.38-.42.23.51.22.6-.94,2.32-.94,2.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.88,107.08a2.89,2.89,0,0,1-1.14-.38",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,110s.37-2.29.38-2.4.64-.27.65-.43-1.3-.7-1.38-.42.23.51.22.6-.94,2.32-.94,2.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.27,112.38l2-1.42c.09-.07.64.25.76.15s-.42-1.42-.68-1.28-.19.53-.27.58-2.3,1-2.3,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,111a2.85,2.85,0,0,1-.53-1.08",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.27,112.38l2-1.42c.09-.07.64.25.76.15s-.42-1.42-.68-1.28-.19.53-.27.58-2.3,1-2.3,1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2,115.72l2.4.38c.1,0,.27.63.43.64s.7-1.3.42-1.38-.51.23-.6.22-2.33-.94-2.33-.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.09,116.62a2.82,2.82,0,0,1,.38-1.13",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2,115.72l2.4.38c.1,0,.27.63.43.64s.7-1.3.42-1.38-.51.23-.6.22-2.33-.94-2.33-.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.78,118l1.43,2c.07.09-.25.64-.15.76s1.42-.41,1.28-.68-.53-.19-.58-.26-1-2.31-1-2.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.19,120.7a2.86,2.86,0,0,1,1.07-.53",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.78,118l1.43,2c.07.09-.25.64-.15.76s1.42-.41,1.28-.68-.53-.19-.58-.26-1-2.31-1-2.31Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.45,117.94s-.36,2.29-.38,2.4-.63.27-.65.43,1.3.7,1.39.42-.24-.51-.22-.6.94-2.32.94-2.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.55,120.83a2.82,2.82,0,0,1,1.13.38",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.45,117.94s-.36,2.29-.38,2.4-.63.27-.65.43,1.3.7,1.39.42-.24-.51-.22-.6.94-2.32.94-2.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.15,115.53l-2,1.42c-.09.07-.64-.25-.77-.15s.42,1.42.68,1.28.2-.53.27-.58,2.31-1,2.31-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.47,116.93A2.85,2.85,0,0,1,411,118",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.15,115.53l-2,1.42c-.09.07-.64-.25-.77-.15s.42,1.42.68,1.28.2-.53.27-.58,2.31-1,2.31-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.23,112.19l-2.4-.38c-.11,0-.27-.63-.43-.64s-.71,1.3-.42,1.38.51-.24.6-.22,2.32.94,2.32.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.34,111.29a2.73,2.73,0,0,1-.39,1.13",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.23,112.19l-2.4-.38c-.11,0-.27-.63-.43-.64s-.71,1.3-.42,1.38.51-.24.6-.22,2.32.94,2.32.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.14,109.54l-1.5-3c-.06-.09.32-.6.24-.74s-1.46.25-1.36.53.51.26.55.33,1,3.27,1,3.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.75,105.84a2.85,2.85,0,0,1-1.14.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.52,110.13s1-3.07,1-3.18.67-.19.7-.35-1.21-.86-1.33-.59.17.55.15.63-1.59,3-1.59,3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.15,106.53a2.82,2.82,0,0,1-1.09-.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.49,112.94l3-1.51c.09-.05.61.33.74.24s-.25-1.46-.52-1.35-.26.5-.34.54-3.27,1-3.27,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.18,111.54a2.85,2.85,0,0,1-.4-1.14",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.89,116.31s3.07,1,3.18,1,.2.67.35.7.86-1.21.59-1.33-.54.18-.63.15-3-1.59-3-1.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.49,117.94a2.75,2.75,0,0,1,.53-1.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.08,118.28l1.51,3c.06.1-.33.61-.24.74s1.46-.24,1.36-.52-.51-.26-.55-.34-1-3.27-1-3.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.48,122a2.7,2.7,0,0,1,1.14-.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.71,117.69l-1,3.17c0,.11-.67.2-.7.35s1.21.86,1.33.59-.17-.54-.15-.62,1.59-3,1.59-3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.08,121.29a2.82,2.82,0,0,1,1.09.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.74,114.88l-3,1.51c-.09,0-.61-.33-.74-.25s.25,1.47.52,1.36.26-.51.34-.54,3.27-1,3.27-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.05,116.27a2.85,2.85,0,0,1,.4,1.14",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.34,111.5l-3.18-1c-.1,0-.2-.66-.35-.7s-.86,1.21-.59,1.33.54-.17.62-.14,3,1.59,3,1.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.74,109.88a2.81,2.81,0,0,1-.53,1.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.76,115.14a5.46,5.46,0,0,0,6.5,4.26,5.64,5.64,0,1,0-2.58-11,5.19,5.19,0,0,0-1.9.86A5.68,5.68,0,0,0,411.76,115.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.76,115.14a5.46,5.46,0,0,0,6.5,4.26,5.59,5.59,0,0,0,4.1-3.22c-1.31,1-4,2.7-6.74,1.41-3.76-1.78-3.5-6.08-1.84-8.32A5.68,5.68,0,0,0,411.76,115.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7,109.84H418s0,0,0-.14c-.08-.52-.35-2.28-.37-2.38s.6-.51.57-.69-.36-.15-.73-.18-.92,0-.92.18.43.48.43.58S416.7,109.84,416.7,109.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,106.61a3.17,3.17,0,0,1-1.36,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,109.7c-.08-.52-.35-2.28-.37-2.38s.6-.51.57-.69-.36-.15-.73-.18a.84.84,0,0,1,.34.15s0,0,0,0,0,.09,0,.14-.4.29-.41.43S417.94,109.63,418,109.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.76,110.54l.91.9,0,0h0l1.48-2c.07-.1.78.07.88-.08s-.4-.73-.77-1c-.18-.13-.33-.21-.4-.13s0,.65-.1.72S419.76,110.54,419.76,110.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,109.17a3.14,3.14,0,0,1-.94-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.71,111.39l1.48-2c.07-.1.78.07.88-.08s-.4-.73-.77-1a2.84,2.84,0,0,1,.34.55.35.35,0,0,1,0,.13s0,.09,0,.11-.45-.07-.6,0A26,26,0,0,0,420.71,111.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.44,113.2v1.28h0l2.52-.39c.12,0,.51.6.69.56a2.17,2.17,0,0,0,.06-1.62l-.06,0c-.21,0-.49.43-.58.44S421.44,113.2,421.44,113.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.68,114.5a3.11,3.11,0,0,1,0-1.36Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.45,114.48l2.52-.39c.12,0,.51.6.69.56a2.17,2.17,0,0,0,.06-1.62,1.19,1.19,0,0,1,0,1,.24.24,0,0,1-.06.11s-.07.08-.1.07-.36-.33-.57-.31S421.58,114.44,421.45,114.48Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.9,118.69c.08,0,0,.44,0,.69a.24.24,0,0,0,.06.19c.15.09,1.4-.93,1.17-1.17s-.65,0-.72-.1-.72-.84-1.19-1.41h0l-.5-.62-.91.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,119.48a3.21,3.21,0,0,1,1-.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.93,119.38a.24.24,0,0,0,.06.19c.15.09,1.4-.93,1.17-1.17s-.65,0-.72-.1-.72-.84-1.19-1.41a12.39,12.39,0,0,0,1,1.59c.11,0,.43,0,.47.21a.26.26,0,0,1,0,.1,1.78,1.78,0,0,1-.24.33,2.65,2.65,0,0,1-.3.29l-.05,0a.18.18,0,0,1-.14,0A.26.26,0,0,1,421.93,119.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.63,121.15s.11.09.26.12c.47.11,1.39.14,1.39-.12s-.43-.48-.44-.57.12-1.35.19-2.09h0c0-.32.06-.55.06-.55h-1.28s.37,2.41.38,2.53S416.6,121,416.63,121.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.78,121.18a3.16,3.16,0,0,1,1.37,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.89,121.27c.47.11,1.39.14,1.39-.12s-.43-.48-.44-.57.12-1.35.19-2.09c-.14.69-.4,2-.38,2.09s.34.42.25.54l0,0-.19.06A4,4,0,0,1,416.89,121.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.14,119.18c.28.32.62.6.75.48s0-.65.1-.72,1.51-1.27,1.92-1.6h0l.11-.09-.9-.91-1.52,2.06c-.07.1-.78-.06-.88.09S411.88,118.88,412.14,119.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.81,118.61a3.21,3.21,0,0,1,.94,1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.14,119.18c.28.32.62.6.75.48s0-.65.1-.72,1.51-1.27,1.92-1.6h0s-2.15,1.36-2.16,1.47,0,.58-.12.6l-.09,0A2.52,2.52,0,0,1,412.14,119.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.13,114.78c.11,0,.24-.12.35-.24a1,1,0,0,1,.23-.2c.17,0,2.63.25,2.63.25v-1.28l-.51.07h0l-2,.3c-.13,0-.51-.59-.69-.56S409.8,114.78,410.13,114.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.11,113.28a3.33,3.33,0,0,1,0,1.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.13,114.78c.11,0,.24-.12.35-.24l-.31,0a.09.09,0,0,1-.06,0,.2.2,0,0,1,0-.08,1.41,1.41,0,0,1,0-.61,1.25,1.25,0,0,1,.06-.18h0s.05-.07.08-.07.45.35.68.32,1.29-.34,1.91-.51l-2,.3c-.13,0-.51-.59-.69-.56S409.8,114.78,410.13,114.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.63,109.39c.14.14.65,0,.72.09s1.69,2,1.69,2l.91-.91-.2-.14h0l-1.87-1.37c-.09-.08.07-.78-.08-.88s-.45.19-.75.48h0C411.75,109,411.52,109.27,411.63,109.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.67,108.31a3.14,3.14,0,0,1-1,.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.05,108.7a1.2,1.2,0,0,1,.36-.15h.08c.08,0,.13,0,.14.1s-.09.53,0,.64,2,1.15,2.12,1.19l-1.87-1.37c-.09-.08.07-.78-.08-.88S412.35,108.41,412.05,108.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.94,117.33c.06.11.26.14.46,0s.32-.27.26-.39-.26-.14-.46,0S418.89,117.21,418.94,117.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.08,117.75a1.36,1.36,0,0,0,.78-.37.41.41,0,0,0,.13-.46c-.09-.22-.29-.21-.48-.23,0,0,0,0,0,0,.33,0,.73.1.67.51s-.68.68-1.1.65C419,117.83,419,117.76,419.08,117.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.19,110.51c0,.13.2.27.5.31s.54,0,.55-.17-.2-.27-.49-.31S418.21,110.38,418.19,110.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.94,111.09a1,1,0,0,0,.44-.14.32.32,0,0,0,.08-.47,1,1,0,0,0-.71-.39s0,0,0,0c.33,0,.82.18.93.53s-.42.55-.75.55C418.91,111.14,418.92,111.1,418.94,111.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.1,112.16c0,.13.19.24.41.23s.39-.12.38-.25-.18-.23-.4-.23S414.1,112,414.1,112.16Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.54,112.69a1.93,1.93,0,0,0,.61-.3c.31-.34-.17-.54-.43-.62,0,0,0,0,0,0,.29,0,.72.2.66.56s-.54.5-.83.45A0,0,0,0,1,414.54,112.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.43,115.85c0,.1.15.18.32.17s.3-.1.29-.2-.14-.18-.31-.17S420.43,115.75,420.43,115.85Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.78,116.25a1.4,1.4,0,0,0,.47-.24c.23-.27-.14-.42-.35-.47,0,0,0,0,0,0,.22,0,.56.14.52.42s-.4.4-.64.36C420.76,116.3,420.76,116.26,420.78,116.25Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.09,116c0,.16.17.33.44.38s.5,0,.53-.21-.16-.33-.43-.37S413.12,115.82,413.09,116Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.05,115.71h0c.25.19.61.51.35.85a.76.76,0,0,1-1,.15s0,0,0,0a1.35,1.35,0,0,0,.69-.09C414.58,116.35,414.29,115.93,414.05,115.71Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.59,161.21l-1.43-2c-.07-.09.25-.65.15-.77s-1.41.42-1.28.68.54.2.58.27,1,2.31,1,2.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.19,158.53a2.94,2.94,0,0,1-1.08.53",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.59,161.21l-1.43-2c-.07-.09.25-.65.15-.77s-1.41.42-1.28.68.54.2.58.27,1,2.31,1,2.31Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.92,161.29s.36-2.29.38-2.4.63-.27.65-.43-1.3-.71-1.39-.42.24.51.22.59-.94,2.33-.94,2.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.83,158.4a2.8,2.8,0,0,1-1.14-.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.92,161.29s.36-2.29.38-2.4.63-.27.65-.43-1.3-.71-1.39-.42.24.51.22.59-.94,2.33-.94,2.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,163.7l2-1.43c.08-.06.64.26.76.16s-.42-1.42-.68-1.28-.2.53-.27.58-2.31,1-2.31,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.9,162.3a2.85,2.85,0,0,1-.53-1.08",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,163.7l2-1.43c.08-.06.64.26.76.16s-.42-1.42-.68-1.28-.2.53-.27.58-2.31,1-2.31,1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.14,167l2.4.38c.11,0,.28.64.43.65s.71-1.3.43-1.38-.52.23-.6.22-2.33-.94-2.33-.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,167.94a2.8,2.8,0,0,1,.39-1.14",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.14,167l2.4.38c.11,0,.28.64.43.65s.71-1.3.43-1.38-.52.23-.6.22-2.33-.94-2.33-.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.73,169.33l1.43,2c.06.09-.25.64-.16.76s1.42-.42,1.28-.68-.53-.19-.57-.27-1-2.3-1-2.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.13,172a2.7,2.7,0,0,1,1.08-.53",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.73,169.33l1.43,2c.06.09-.25.64-.16.76s1.42-.42,1.28-.68-.53-.19-.57-.27-1-2.3-1-2.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,169.25s-.37,2.3-.38,2.41-.63.27-.65.43,1.3.7,1.39.42-.24-.52-.22-.6.93-2.33.93-2.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.49,172.15a2.89,2.89,0,0,1,1.14.38",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,169.25s-.37,2.3-.38,2.41-.63.27-.65.43,1.3.7,1.39.42-.24-.52-.22-.6.93-2.33.93-2.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,166.84l-2,1.43c-.09.07-.64-.25-.76-.15s.42,1.42.68,1.28.2-.53.27-.58,2.31-1,2.31-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.41,168.25a2.71,2.71,0,0,1,.53,1.07",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,166.84l-2,1.43c-.09.07-.64-.25-.76-.15s.42,1.42.68,1.28.2-.53.27-.58,2.31-1,2.31-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.18,163.51l-2.4-.38c-.11,0-.28-.63-.43-.65s-.71,1.3-.43,1.39.52-.24.6-.22,2.33.94,2.33.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.29,162.61a2.73,2.73,0,0,1-.39,1.13",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.18,163.51l-2.4-.38c-.11,0-.28-.63-.43-.65s-.71,1.3-.43,1.39.52-.24.6-.22,2.33.94,2.33.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.09,160.85l-1.51-3c-.05-.09.33-.61.25-.74s-1.47.25-1.36.52.5.27.54.34,1,3.27,1,3.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.69,157.16a2.79,2.79,0,0,1-1.14.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.47,161.45s1-3.07,1-3.18.66-.19.69-.35-1.21-.86-1.33-.59.18.54.15.63-1.59,3-1.59,3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.09,157.85a2.82,2.82,0,0,1-1.09-.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.43,164.26l3-1.51c.1-.06.61.33.75.24s-.25-1.46-.53-1.36-.26.51-.34.55-3.27,1-3.27,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.13,162.86a2.85,2.85,0,0,1-.4-1.14",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.84,167.63l3.17,1c.11,0,.2.67.35.7s.86-1.21.59-1.33-.54.17-.62.15-3-1.59-3-1.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44,169.26a2.82,2.82,0,0,1,.52-1.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,169.6l1.51,3c0,.1-.33.61-.25.74s1.47-.25,1.36-.52-.5-.26-.54-.34-1-3.27-1-3.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.43,173.29a2.79,2.79,0,0,1,1.14-.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.65,169s-1,3.07-1,3.18-.66.2-.69.35,1.21.86,1.33.59-.18-.54-.15-.62,1.59-3,1.59-3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,172.6a2.91,2.91,0,0,1,1.09.53",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.69,166.2s-2.89,1.45-3,1.51-.61-.33-.75-.25.25,1.46.53,1.36.26-.51.34-.55,3.27-1,3.27-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,167.59a2.85,2.85,0,0,1,.4,1.14",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,162.82l-3.17-1c-.11,0-.2-.66-.35-.7s-.86,1.21-.59,1.33.54-.17.62-.14,3,1.58,3,1.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.68,161.19a2.82,2.82,0,0,1-.52,1.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,166.46a5.47,5.47,0,0,0,6.5,4.26,5.23,5.23,0,0,0,4.28-6.63,5.54,5.54,0,0,0-6.85-4.36,5.07,5.07,0,0,0-1.91.86A5.72,5.72,0,0,0,329.7,166.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,166.46a5.47,5.47,0,0,0,6.5,4.26,5.62,5.62,0,0,0,4.11-3.23c-1.31,1-4,2.71-6.74,1.42-3.76-1.78-3.5-6.08-1.85-8.32A5.72,5.72,0,0,0,329.7,166.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.64,161.16h1.29l0-.14c-.08-.52-.35-2.28-.36-2.39s.6-.51.56-.68-.36-.16-.72-.19-.93,0-.93.19.43.48.44.58S334.64,161.16,334.64,161.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,157.92a3.16,3.16,0,0,1-1.37,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.9,161c-.08-.52-.35-2.28-.36-2.39s.6-.51.56-.68-.36-.16-.72-.19a1.07,1.07,0,0,1,.34.16l0,0a.13.13,0,0,1,0,.14c-.12.14-.4.3-.41.44S335.88,161,335.9,161Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.71,161.86l.91.9,0,0h0l1.47-2c.08-.1.78.06.88-.09s-.39-.72-.77-1c-.17-.14-.32-.21-.4-.13s0,.64-.09.72S337.71,161.86,337.71,161.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.92,160.49a3.23,3.23,0,0,1-.93-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.66,162.71l1.47-2c.08-.1.78.06.88-.09s-.39-.72-.77-1a2,2,0,0,1,.34.55.41.41,0,0,1,0,.12c0,.06,0,.1,0,.11s-.46-.06-.6,0A23.9,23.9,0,0,0,338.66,162.71Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.39,164.52v1.28h0l2.53-.39c.12,0,.51.6.68.56a2.22,2.22,0,0,0,.07-1.62.09.09,0,0,0-.07,0c-.2,0-.48.43-.58.44S339.39,164.52,339.39,164.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.63,165.82a3.16,3.16,0,0,1,0-1.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.39,165.8l2.53-.39c.12,0,.51.6.68.56a2.22,2.22,0,0,0,.07-1.62,1.28,1.28,0,0,1,0,1l-.06.11s-.08.08-.11.07-.36-.33-.57-.32S339.53,165.76,339.39,165.8Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,170c.07.06,0,.45,0,.69a.29.29,0,0,0,.07.2c.14.09,1.4-.94,1.16-1.17s-.64,0-.72-.1-.71-.84-1.18-1.42h0l-.51-.62-.9.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.06,170.79a3.23,3.23,0,0,1,1-.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.87,170.69a.29.29,0,0,0,.07.2c.14.09,1.4-.94,1.16-1.17s-.64,0-.72-.1-.71-.84-1.18-1.42a12.27,12.27,0,0,0,1,1.6c.12,0,.44,0,.47.21a.16.16,0,0,1,0,.1,1.67,1.67,0,0,1-.23.33,2.06,2.06,0,0,1-.31.29l-.05,0a.18.18,0,0,1-.14,0A.23.23,0,0,1,339.87,170.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.58,172.47s.11.09.26.12c.46.11,1.39.14,1.39-.12s-.43-.48-.44-.58.11-1.34.19-2.08h0c0-.32,0-.55,0-.55h-1.28l.39,2.53C335.16,171.91,334.54,172.3,334.58,172.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.73,172.5a3.16,3.16,0,0,1,1.37,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.84,172.59c.46.11,1.39.14,1.39-.12s-.43-.48-.44-.58.11-1.34.19-2.08c-.14.69-.41,2-.39,2.09s.35.42.26.54l0,0-.18.05A3.46,3.46,0,0,1,334.84,172.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.08,170.49c.29.32.63.61.75.48s0-.64.1-.72,1.51-1.26,1.93-1.59h0l.11-.09-.91-.91-1.51,2.06c-.08.1-.79-.06-.89.09S329.83,170.2,330.08,170.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.75,169.93a3.21,3.21,0,0,1,.94,1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.08,170.49c.29.32.63.61.75.48s0-.64.1-.72,1.51-1.26,1.93-1.59h0s-2.15,1.36-2.17,1.47,0,.58-.11.59a.14.14,0,0,1-.09,0A2,2,0,0,1,330.08,170.49Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.08,166.1c.1,0,.23-.12.35-.24s.18-.2.23-.2,2.63.25,2.63.25v-1.29l-.52.08h0l-2,.31c-.12,0-.51-.6-.68-.56S327.74,166.1,328.08,166.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.05,164.6a3.16,3.16,0,0,1,0,1.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.08,166.1c.1,0,.23-.12.35-.24a1.66,1.66,0,0,1-.32,0,.09.09,0,0,1-.06,0l0-.08a1.27,1.27,0,0,1,0-.61.38.38,0,0,1,.06-.18h0c0-.05,0-.07.07-.07s.45.35.69.31,1.28-.33,1.9-.51l-2,.31c-.12,0-.51-.6-.68-.56S327.74,166.1,328.08,166.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.57,160.7c.15.15.65,0,.73.1s1.68,2,1.68,2l.91-.91-.2-.14h0l-1.86-1.37c-.1-.08.06-.78-.09-.88s-.44.19-.75.47h0C329.7,160.28,329.46,160.59,329.57,160.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.62,159.63a3.23,3.23,0,0,1-1,.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,160a1.54,1.54,0,0,1,.37-.14h.08a.11.11,0,0,1,.13.1c0,.19-.08.53,0,.64s2,1.14,2.12,1.19l-1.86-1.37c-.1-.08.06-.78-.09-.88S330.3,159.73,330,160Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.89,168.64c.05.12.26.15.46.05s.31-.26.26-.38-.26-.14-.46-.05S336.83,168.52,336.89,168.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,169.07a1.39,1.39,0,0,0,.79-.37.42.42,0,0,0,.12-.46c-.08-.22-.28-.21-.48-.23,0,0,0,0,0,0,.34,0,.73.1.67.51s-.68.68-1.09.65C337,169.14,337,169.08,337,169.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.14,161.83c0,.13.2.27.49.3s.54,0,.56-.16-.21-.27-.5-.31S336.15,161.7,336.14,161.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.89,162.41a1.28,1.28,0,0,0,.43-.14.32.32,0,0,0,.09-.47,1,1,0,0,0-.71-.39s0,0,0,0c.33,0,.83.18.93.53s-.42.55-.74.54C336.86,162.46,336.86,162.42,336.89,162.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.05,163.48c0,.13.18.23.4.23s.39-.12.39-.25-.18-.23-.4-.23S332.05,163.35,332.05,163.48Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.48,164a1.72,1.72,0,0,0,.62-.31c.31-.33-.17-.53-.44-.61,0,0,0,0,0,0,.28,0,.72.2.66.55s-.54.51-.84.45A0,0,0,0,1,332.48,164Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.38,167.17c0,.1.14.18.31.17s.3-.1.3-.2-.15-.18-.32-.17S338.37,167.07,338.38,167.17Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.72,167.57a1.19,1.19,0,0,0,.47-.25c.24-.26-.14-.41-.34-.46,0,0,0,0,0,0,.22,0,.56.14.52.42s-.41.4-.64.36C338.7,167.62,338.7,167.58,338.72,167.57Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,167.3c0,.16.16.33.43.38s.51-.05.54-.21-.17-.33-.44-.38S331.07,167.14,331,167.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,167h0c.25.19.6.5.35.85a.78.78,0,0,1-1,.15s0-.06,0-.05a1.35,1.35,0,0,0,.69-.09C332.53,167.67,332.24,167.25,332,167Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.71,94.82l-4.14,3c-.19.13-1.35-.53-1.6-.32s.88,3,1.43,2.69c.33-.18.41-1.12.56-1.22s4.86-2.07,4.86-2.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.06,97.77a5.83,5.83,0,0,1,1.11,2.27",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.71,94.82l-4.14,3c-.19.13-1.35-.53-1.6-.32s.88,3,1.43,2.69c.33-.18.41-1.12.56-1.22s4.86-2.07,4.86-2.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.87,87.81l-5.05-.8c-.23,0-.58-1.33-.9-1.36s-1.49,2.73-.9,2.91c.36.11,1.09-.5,1.26-.46s4.9,2,4.9,2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.79,85.9a5.93,5.93,0,0,1-.81,2.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.87,87.81l-5.05-.8c-.23,0-.58-1.33-.9-1.36s-1.49,2.73-.9,2.91c.36.11,1.09-.5,1.26-.46s4.9,2,4.9,2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,83l-3-4.14c-.13-.18.53-1.35.32-1.6s-3,.88-2.69,1.43c.18.33,1.12.41,1.22.56s2.07,4.86,2.07,4.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,77.32a6,6,0,0,1-2.27,1.12",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,83l-3-4.14c-.13-.18.53-1.35.32-1.6s-3,.88-2.69,1.43c.18.33,1.12.41,1.22.56s2.07,4.86,2.07,4.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,83.14s.76-4.83.8-5.06,1.33-.57,1.36-.9-2.73-1.49-2.91-.9c-.11.36.5,1.09.46,1.26s-2,4.9-2,4.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.87,77.05a5.93,5.93,0,0,1-2.39-.81",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,83.14s.76-4.83.8-5.06,1.33-.57,1.36-.9-2.73-1.49-2.91-.9c-.11.36.5,1.09.46,1.26s-2,4.9-2,4.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.8,88.21l4.14-3c.18-.13,1.35.54,1.6.33s-.88-3-1.43-2.7c-.33.18-.41,1.12-.56,1.22s-4.86,2.07-4.86,2.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.45,85.26A6,6,0,0,1,369.33,83",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.8,88.21l4.14-3c.18-.13,1.35.54,1.6.33s-.88-3-1.43-2.7c-.33.18-.41,1.12-.56,1.22s-4.86,2.07-4.86,2.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.64,95.22l5.05.8c.23,0,.58,1.33.9,1.36s1.49-2.73.9-2.91c-.36-.11-1.09.5-1.26.46s-4.9-2-4.9-2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.72,97.13a5.93,5.93,0,0,1,.81-2.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.64,95.22l5.05.8c.23,0,.58,1.33.9,1.36s1.49-2.73.9-2.91c-.36-.11-1.09.5-1.26.46s-4.9-2-4.9-2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.56,100.06l3,4.14c.13.19-.53,1.35-.33,1.6s3-.88,2.7-1.43c-.18-.33-1.12-.41-1.22-.56S361.65,99,361.65,99Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.51,105.71a5.83,5.83,0,0,1,2.27-1.11",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.56,100.06l3,4.14c.13.19-.53,1.35-.33,1.6s3-.88,2.7-1.43c-.18-.33-1.12-.41-1.22-.56S361.65,99,361.65,99Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.55,99.9s-.77,4.82-.8,5-1.33.58-1.36.9,2.73,1.49,2.91.9c.11-.36-.5-1.09-.46-1.26s2-4.9,2-4.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.64,106a5.93,5.93,0,0,1,2.39.81",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.55,99.9s-.77,4.82-.8,5-1.33.58-1.36.9,2.73,1.49,2.91.9c.11-.36-.5-1.09-.46-1.26s2-4.9,2-4.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,93.77l-6.28,3.17c-.2.11-1.28-.69-1.56-.51s.52,3.08,1.1,2.86c.35-.14.55-1.07.71-1.15S347.81,96,347.81,96Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.18,96.7a6,6,0,0,1,.84,2.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.21,86.66s-6.47-2.13-6.69-2.19-.41-1.4-.74-1.47-1.81,2.55-1.24,2.8c.34.16,1.15-.36,1.32-.31s6.38,3.35,6.38,3.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.63,83.24a5.94,5.94,0,0,1-1.1,2.29",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.11,82.52s-3.06-6.07-3.17-6.27.69-1.28.51-1.57-3.08.53-2.86,1.11c.14.35,1.07.55,1.15.71s2.15,6.88,2.15,6.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.18,74.74a6,6,0,0,1-2.4.85",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.22,83.77s2.13-6.46,2.19-6.68,1.4-.42,1.47-.74-2.55-1.81-2.8-1.24c-.16.34.36,1.14.31,1.31S359,82.81,359,82.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.64,76.2a6.1,6.1,0,0,1-2.29-1.1",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,89.68l6.27-3.17c.2-.12,1.28.69,1.56.51s-.52-3.08-1.1-2.86c-.35.14-.55,1.07-.71,1.15s-6.88,2.15-6.88,2.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.14,86.74a5.91,5.91,0,0,1-.85-2.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.11,96.79,370.79,99c.22.06.42,1.39.74,1.47s1.81-2.55,1.24-2.81c-.34-.15-1.14.37-1.31.31s-6.39-3.34-6.39-3.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.68,100.21a6,6,0,0,1,1.1-2.29",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2,100.92s3.06,6.08,3.17,6.28-.69,1.28-.51,1.56,3.08-.52,2.86-1.1c-.14-.35-1.07-.55-1.15-.71s-2.15-6.88-2.15-6.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.14,108.7a6,6,0,0,1,2.39-.84",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.09,99.67s-2.12,6.46-2.19,6.69-1.39.41-1.47.74,2.55,1.81,2.81,1.24c.15-.34-.37-1.15-.31-1.32s3.34-6.38,3.34-6.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.67,107.25a5.88,5.88,0,0,1,2.29,1.1",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.59,94.74c1.69,7.19,8.82,9.52,14.16,8.26a12.26,12.26,0,0,0,5.86-3.21,11,11,0,0,0,3.1-10.47c-1.48-6.32-6.49-10.75-13.95-9a13,13,0,0,0-5.7,2.86A11.65,11.65,0,0,0,344.59,94.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.59,94.74c1.69,7.19,8.82,9.52,14.16,8.26a12.26,12.26,0,0,0,5.86-3.21c-3.13,1.49-7.09,2.34-11.05.46-7.6-3.6-8.06-11.67-5.5-17.07A11.65,11.65,0,0,0,344.59,94.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.6,92.6V89.9l-.3,0-5,.76c-.26,0-1.07-1.25-1.44-1.18-.17,0-.32.75-.39,1.52-.07.94,0,2,.39,2s1-.91,1.22-.93S347.6,92.6,347.6,92.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.79,89.85a6.68,6.68,0,0,1-.09,2.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.3,90l-5,.76c-.26,0-1.07-1.25-1.44-1.18-.17,0-.32.75-.39,1.52a2.25,2.25,0,0,1,.32-.72l.08,0c.1-.06.19,0,.3.06.28.25.62.84.91.86S347.15,90,347.3,90Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.06,86.15,351,84.24l-.1-.08h0l-4.22-3.1c-.21-.16.13-1.64-.18-1.85s-1.53.83-2.17,1.62c-.29.36-.44.67-.28.83s1.35.08,1.51.21S349.06,86.15,349.06,86.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.19,79.38a6.84,6.84,0,0,1-2.1,2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.85,84.15l-4.22-3.1c-.21-.16.13-1.64-.18-1.85s-1.53.83-2.17,1.62a4.61,4.61,0,0,1,1.15-.72,1.23,1.23,0,0,1,.26-.08c.13,0,.21,0,.23.07.1.3-.13,1,.05,1.27A55.89,55.89,0,0,0,350.85,84.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.66,82.62h2.7v0c0-.3-.77-5.06-.81-5.31s1.26-1.07,1.19-1.44-3-.65-3.42-.14a.2.2,0,0,0-.06.14c0,.43.91,1,.93,1.22C355.21,77.42,354.66,82.62,354.66,82.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.41,75.8a6.68,6.68,0,0,1-2.88-.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.35,82.6c0-.3-.77-5.06-.81-5.31s1.26-1.07,1.19-1.44-3-.65-3.42-.14a2.61,2.61,0,0,1,2.11.06,1.16,1.16,0,0,1,.22.13c.11.08.17.16.16.22-.07.3-.7.77-.67,1.2S357.28,82.32,357.35,82.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.21,81.64c.11-.15.93,0,1.45,0,.2,0,.35,0,.41-.13.2-.31-2-2.95-2.46-2.45-.3.3-.08,1.35-.21,1.51s-1.77,1.51-3,2.49h0l-1.3,1L363,86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.88,81.2a6.71,6.71,0,0,1-2-2.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.66,81.59c.2,0,.35,0,.41-.13.2-.31-2-2.95-2.46-2.45-.3.3-.08,1.35-.21,1.51s-1.77,1.51-3,2.49a25.47,25.47,0,0,0,3.36-2.17c.11-.25.11-.92.44-1a.36.36,0,0,1,.22.06,4.12,4.12,0,0,1,.69.49,4.39,4.39,0,0,1,.6.65.46.46,0,0,1,.07.1c.08.13.11.23.08.29A.38.38,0,0,1,367.66,81.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.41,92.74c.09,0,.17-.23.24-.54.23-1,.3-2.93-.24-2.94s-1,.91-1.22.93-2.83-.24-4.39-.4h0l-1.15-.12v2.7l5.32-.81C370.22,91.52,371,92.82,371.41,92.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.46,92.42a6.68,6.68,0,0,1,.09-2.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.65,92.2c.23-1,.3-2.93-.24-2.94s-1,.91-1.22.93-2.83-.24-4.39-.4c1.45.29,4.27.85,4.4.82s.89-.73,1.14-.54a.13.13,0,0,1,.05.07,1.39,1.39,0,0,1,.12.39A7.58,7.58,0,0,1,371.65,92.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.24,102.2c.68-.6,1.27-1.32,1-1.58s-1.36-.08-1.51-.21-2.66-3.17-3.36-4h0a2.17,2.17,0,0,0-.19-.23l-1.9,1.9,4.33,3.19c.21.16-.13,1.65.19,1.86C366,103.18,366.62,102.74,367.24,102.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.06,102.89a6.71,6.71,0,0,1,2.1-2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.24,102.2c.68-.6,1.27-1.32,1-1.58s-1.36-.08-1.51-.21-2.66-3.17-3.36-4h0s2.87,4.52,3.11,4.55,1.21-.06,1.25.25a.74.74,0,0,1,0,.19A4.35,4.35,0,0,1,367.24,102.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,106.42c0-.23-.25-.5-.49-.74s-.42-.39-.43-.48c0-.35.52-5.54.52-5.54h-2.7l.17,1.09v0c.23,1.5.62,4,.64,4.21s-1.25,1.07-1.18,1.44S358,107.13,358,106.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.84,106.47a6.68,6.68,0,0,1,2.88.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,106.42c0-.23-.25-.5-.49-.74a4.85,4.85,0,0,1,0,.67.14.14,0,0,1-.08.12.48.48,0,0,1-.16.08,3,3,0,0,1-1.29,0,2.09,2.09,0,0,1-.38-.13h0c-.09,0-.14-.1-.14-.16,0-.34.73-1,.66-1.44s-.71-2.71-1.07-4c.23,1.5.62,4,.64,4.21s-1.25,1.07-1.18,1.44S358,107.13,358,106.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.64,103.27c.3-.3.08-1.36.21-1.52s4.28-3.55,4.28-3.55l-1.9-1.91-.31.42h0c-.78,1.05-2.76,3.75-2.88,3.92s-1.65-.14-1.86.18c-.11.16.41.93,1,1.58h0C345.76,103,346.4,103.51,346.64,103.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.37,101.07a6.73,6.73,0,0,1,2,2.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.19,102.39a2.7,2.7,0,0,1-.31-.77,1.11,1.11,0,0,1,0-.17c0-.15.07-.26.21-.28.4-.07,1.12.17,1.35,0s2.41-4.29,2.5-4.46c-.78,1.05-2.76,3.75-2.88,3.92s-1.65-.14-1.86.18C344.07,101,344.59,101.74,345.19,102.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,98.61c.11.25.54.3,1,.1s.66-.55.55-.8-.55-.3-1-.11S354.85,98.36,355,98.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.24,99.5a2.83,2.83,0,0,0,1.66-.78.88.88,0,0,0,.26-1c-.17-.45-.59-.43-1-.47,0,0,0,0,0,0,.7-.08,1.54.21,1.41,1.06-.15,1-1.42,1.43-2.3,1.37C355.17,99.66,355.15,99.52,355.24,99.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.37,84.84c0,.27.56.44,1.17.37s1.09-.34,1.06-.62-.55-.44-1.17-.37S356.34,84.56,356.37,84.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.21,85.65a2.37,2.37,0,0,0,.81-.51.68.68,0,0,0-.06-1,2.08,2.08,0,0,0-1.64-.43s0,0,0,0c.68-.13,1.77-.05,2.17.62.52.87-.59,1.33-1.25,1.49C358.17,85.77,358.15,85.67,358.21,85.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,93.82c0,.27.39.49.85.48s.83-.25.82-.53-.39-.49-.85-.48S362,93.54,362,93.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.94,94.93a3.42,3.42,0,0,0,1.29-.65c.65-.7-.36-1.13-.91-1.29a0,0,0,0,1,0,0c.6.06,1.51.43,1.38,1.18s-1.13,1-1.76.95A.07.07,0,0,1,362.94,94.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.22,90.82c-.05.21.2.43.55.51s.67,0,.71-.25-.2-.44-.55-.51S360.26,90.61,360.22,90.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.71,91.82a2.86,2.86,0,0,0,1.09-.26c.62-.42-.07-.92-.46-1.14,0,0,0,0,0,0,.45.14,1.07.58.84,1.12s-1,.6-1.49.41C360.65,91.9,360.66,91.82,360.71,91.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.44,91.63c-.06.34.35.69.91.79s1.07-.1,1.13-.44-.35-.69-.92-.79S347.49,91.29,347.44,91.63Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.46,91.06a0,0,0,1,1,0,0c.54.4,1.28,1.06.75,1.78a1.6,1.6,0,0,1-2,.32.06.06,0,0,1,0-.11,2.66,2.66,0,0,0,1.45-.19C350.57,92.4,350,91.51,349.46,91.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.13,168.47l-4.14,3c-.18.14-1.35-.53-1.6-.32s.88,3,1.43,2.69c.33-.17.41-1.12.56-1.22s4.86-2.06,4.86-2.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.48,171.42a5.75,5.75,0,0,1,1.11,2.27",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.13,168.47l-4.14,3c-.18.14-1.35-.53-1.6-.32s.88,3,1.43,2.69c.33-.17.41-1.12.56-1.22s4.86-2.06,4.86-2.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.29,161.45l-5.05-.8c-.22,0-.57-1.33-.9-1.36s-1.49,2.73-.9,2.92c.36.11,1.09-.5,1.26-.47s4.9,2,4.9,2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.21,159.55a5.93,5.93,0,0,1-.81,2.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.29,161.45l-5.05-.8c-.22,0-.57-1.33-.9-1.36s-1.49,2.73-.9,2.92c.36.11,1.09-.5,1.26-.47s4.9,2,4.9,2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.37,156.61l-3-4.14c-.13-.18.54-1.34.33-1.6s-3,.88-2.7,1.43c.18.33,1.12.42,1.22.57s2.07,4.86,2.07,4.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.42,151a6,6,0,0,1-2.27,1.12",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.37,156.61l-3-4.14c-.13-.18.54-1.34.33-1.6s-3,.88-2.7,1.43c.18.33,1.12.42,1.22.57s2.07,4.86,2.07,4.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.38,156.78s.77-4.83.8-5.05,1.33-.58,1.36-.91-2.73-1.49-2.91-.89c-.11.35.5,1.08.46,1.26s-2,4.9-2,4.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.29,150.7a5.84,5.84,0,0,1-2.39-.82",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.38,156.78s.77-4.83.8-5.05,1.33-.58,1.36-.91-2.73-1.49-2.91-.89c-.11.35.5,1.08.46,1.26s-2,4.9-2,4.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.22,161.85l4.14-3c.19-.14,1.35.53,1.6.32s-.88-3-1.43-2.69c-.33.17-.41,1.12-.56,1.21s-4.86,2.07-4.86,2.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.87,158.9a5.75,5.75,0,0,1-1.11-2.27",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.22,161.85l4.14-3c.19-.14,1.35.53,1.6.32s-.88-3-1.43-2.69c-.33.17-.41,1.12-.56,1.21s-4.86,2.07-4.86,2.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.06,168.86l5.05.8c.23,0,.58,1.34.9,1.37s1.49-2.73.9-2.92c-.36-.11-1.09.5-1.26.46s-4.9-2-4.9-2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.14,170.77a5.93,5.93,0,0,1,.81-2.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.06,168.86l5.05.8c.23,0,.58,1.34.9,1.37s1.49-2.73.9-2.92c-.36-.11-1.09.5-1.26.46s-4.9-2-4.9-2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,173.71s2.87,3.95,3,4.13-.53,1.35-.32,1.61,3-.88,2.69-1.43c-.18-.33-1.12-.42-1.22-.57s-2.07-4.86-2.07-4.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.93,179.36a6,6,0,0,1,2.27-1.12",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,173.71s2.87,3.95,3,4.13-.53,1.35-.32,1.61,3-.88,2.69-1.43c-.18-.33-1.12-.42-1.22-.57s-2.07-4.86-2.07-4.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,173.54s-.76,4.83-.8,5.05-1.33.58-1.36.91,2.73,1.48,2.91.89c.11-.35-.5-1.08-.46-1.26s2-4.9,2-4.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.06,179.62a5.84,5.84,0,0,1,2.39.82",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,173.54s-.76,4.83-.8,5.05-1.33.58-1.36.91,2.73,1.48,2.91.89c.11-.35-.5-1.08-.46-1.26s2-4.9,2-4.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.38,167.41s-6.08,3.06-6.28,3.18-1.28-.7-1.56-.52.52,3.08,1.1,2.86c.35-.13.55-1.07.71-1.15s6.88-2.15,6.88-2.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.6,170.35a6,6,0,0,1,.84,2.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.63,160.31l-6.69-2.2c-.22-.06-.41-1.39-.74-1.47s-1.81,2.55-1.24,2.81c.34.15,1.15-.37,1.32-.31s6.38,3.34,6.38,3.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.05,156.88a5.88,5.88,0,0,1-1.1,2.29",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.53,156.17s-3.06-6.08-3.17-6.28.69-1.28.51-1.56-3.08.52-2.85,1.1c.13.35,1.06.55,1.14.71s2.15,6.88,2.15,6.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.6,148.39a6,6,0,0,1-2.4.84",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.64,157.42s2.13-6.46,2.19-6.69,1.4-.41,1.47-.74-2.55-1.81-2.8-1.24c-.16.35.36,1.15.31,1.32s-3.35,6.38-3.35,6.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.06,149.84a5.94,5.94,0,0,1-2.29-1.1",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.78,163.33l6.27-3.18c.2-.11,1.28.69,1.57.51s-.53-3.08-1.11-2.85c-.35.13-.55,1.06-.71,1.14s-6.88,2.16-6.88,2.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.56,160.39a6,6,0,0,1-.85-2.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.53,170.43s6.46,2.13,6.68,2.19.42,1.4.74,1.47,1.81-2.55,1.24-2.8c-.34-.15-1.14.37-1.31.31s-6.39-3.35-6.39-3.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.1,173.85a6.1,6.1,0,0,1,1.1-2.29",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.62,174.57s3.06,6.07,3.17,6.27-.69,1.29-.51,1.57,3.08-.53,2.86-1.11c-.14-.35-1.07-.55-1.15-.71s-2.15-6.88-2.15-6.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.56,182.35a5.91,5.91,0,0,1,2.39-.85",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.51,173.32,422.32,180c-.06.22-1.39.42-1.47.74s2.55,1.81,2.81,1.24c.15-.34-.37-1.14-.31-1.31s3.34-6.39,3.34-6.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.09,180.9a6,6,0,0,1,2.29,1.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,168.39c1.69,7.19,8.82,9.51,14.16,8.26a12.36,12.36,0,0,0,5.86-3.22,11,11,0,0,0,3.1-10.47c-1.48-6.31-6.49-10.74-13.95-9a12.89,12.89,0,0,0-5.7,2.85A11.67,11.67,0,0,0,418,168.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,168.39c1.69,7.19,8.82,9.51,14.16,8.26a12.36,12.36,0,0,0,5.86-3.22c-3.13,1.49-7.09,2.34-11,.47-7.6-3.61-8.06-11.68-5.5-17.08A11.67,11.67,0,0,0,418,168.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,166.25v-2.71l-.3.05-5,.77c-.26,0-1.07-1.26-1.44-1.18-.17,0-.32.75-.39,1.52-.07.93,0,2,.39,2s1-.91,1.22-.92S421,166.25,421,166.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.21,163.5a6.63,6.63,0,0,1-.09,2.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.72,163.59l-5,.77c-.26,0-1.07-1.26-1.44-1.18-.17,0-.32.75-.39,1.52a2.05,2.05,0,0,1,.32-.72.21.21,0,0,1,.08-.06c.1-.06.19,0,.3.07.28.25.62.83.91.85S420.57,163.64,420.72,163.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.48,159.79l1.91-1.91-.1-.07h0l-4.22-3.1c-.21-.16.13-1.65-.18-1.86s-1.53.83-2.17,1.62c-.29.36-.44.68-.28.84s1.35.08,1.51.21S422.48,159.79,422.48,159.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.61,153a6.73,6.73,0,0,1-2.1,2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.27,157.8l-4.22-3.1c-.21-.16.13-1.65-.18-1.86s-1.53.83-2.17,1.62a4.92,4.92,0,0,1,1.15-.72.78.78,0,0,1,.26-.07c.13,0,.21,0,.23.06.1.31-.13,1,.05,1.27A56,56,0,0,0,424.27,157.8Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.08,156.26h2.7v0c0-.29-.77-5.05-.81-5.3s1.26-1.07,1.19-1.44-3-.66-3.42-.15a.22.22,0,0,0-.06.15c0,.42.91,1,.93,1.21C428.63,151.07,428.08,156.26,428.08,156.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.83,149.45a6.85,6.85,0,0,1-2.88-.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.77,156.24c0-.29-.77-5.05-.81-5.3s1.26-1.07,1.19-1.44-3-.66-3.42-.15a2.57,2.57,0,0,1,2.11.07.91.91,0,0,1,.22.12c.11.08.17.16.16.22-.07.3-.7.77-.67,1.2S430.7,156,430.77,156.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.63,155.29c.11-.16.93,0,1.45,0a.57.57,0,0,0,.41-.13c.2-.31-2-3-2.46-2.46-.3.3-.08,1.36-.21,1.52s-1.77,1.5-3,2.49h0c-.72.6-1.3,1.06-1.3,1.06l1.91,1.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.3,154.85a6.84,6.84,0,0,1-2-2.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.08,155.24a.57.57,0,0,0,.41-.13c.2-.31-2-3-2.46-2.46-.3.3-.08,1.36-.21,1.52s-1.77,1.5-3,2.49a25.21,25.21,0,0,0,3.36-2.18c.11-.25.11-.92.44-1a.42.42,0,0,1,.22.05,3.88,3.88,0,0,1,.69.5,4.54,4.54,0,0,1,.61.65.33.33,0,0,1,.06.1c.08.12.11.22.08.29A.43.43,0,0,1,441.08,155.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.83,166.38c.09,0,.17-.23.24-.54.23-1,.3-2.93-.24-2.93s-1,.91-1.22.92-2.83-.23-4.39-.4h0l-1.15-.11V166l5.32-.81C443.64,165.16,444.46,166.46,444.83,166.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.88,166.07a6.68,6.68,0,0,1,.09-2.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.07,165.84c.23-1,.3-2.93-.24-2.93s-1,.91-1.22.92-2.83-.23-4.39-.4c1.45.3,4.27.86,4.4.82s.89-.73,1.14-.54a.16.16,0,0,1,.05.08,1.46,1.46,0,0,1,.13.39A8.11,8.11,0,0,1,445.07,165.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.66,175.84c.68-.6,1.27-1.31,1-1.58s-1.36-.07-1.51-.2-2.66-3.18-3.36-4.05h0c-.11-.15-.19-.24-.19-.24l-1.9,1.91,4.33,3.19c.21.15-.13,1.64.19,1.85C439.37,176.82,440.05,176.38,440.66,175.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.48,176.53a6.61,6.61,0,0,1,2.1-2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.66,175.84c.68-.6,1.27-1.31,1-1.58s-1.36-.07-1.51-.2-2.66-3.18-3.36-4.05h0s2.87,4.51,3.11,4.55,1.21-.06,1.25.24a.54.54,0,0,1,0,.2A4.57,4.57,0,0,1,440.66,175.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41,180.06c0-.22-.25-.49-.49-.73s-.42-.39-.43-.49c0-.34.52-5.54.52-5.54h-2.7l.17,1.1h0c.23,1.51.62,4,.64,4.21s-1.25,1.08-1.18,1.44S431.41,180.77,431.41,180.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.26,180.12a6.79,6.79,0,0,1,2.88.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41,180.06c0-.22-.25-.49-.49-.73a4.7,4.7,0,0,1,0,.66.15.15,0,0,1-.07.12.45.45,0,0,1-.17.08,3,3,0,0,1-1.29,0A2.09,2.09,0,0,1,429,180h0c-.09-.05-.14-.1-.14-.15,0-.35.74-1,.66-1.45s-.71-2.7-1.07-4c.23,1.51.62,4,.64,4.21s-1.25,1.08-1.18,1.44S431.41,180.77,431.41,180.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.06,176.91c.3-.3.08-1.36.21-1.52s4.28-3.55,4.28-3.55l-1.9-1.91-.31.42h0l-2.88,3.92c-.16.21-1.65-.13-1.86.18s.41.94,1,1.58h0C419.18,176.65,419.82,177.15,420.06,176.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.79,174.72a6.76,6.76,0,0,1,2,2.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.61,176a2.7,2.7,0,0,1-.31-.77,1,1,0,0,1,0-.17c0-.15.07-.26.21-.28.4-.07,1.12.18,1.35,0s2.41-4.29,2.5-4.46l-2.88,3.92c-.16.21-1.65-.13-1.86.18S418,175.39,418.61,176Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.39,172.25c.11.25.54.3,1,.11s.66-.55.55-.81-.55-.29-1-.1S428.27,172,428.39,172.25Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.66,173.15a2.84,2.84,0,0,0,1.66-.79.88.88,0,0,0,.26-1c-.17-.44-.59-.43-1-.47,0,0,0,0,0,0,.7-.08,1.54.21,1.41,1.07-.15,1-1.42,1.43-2.3,1.36C428.59,173.3,428.57,173.16,428.66,173.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.79,158.48c0,.27.56.44,1.17.38s1.09-.35,1.06-.62-.55-.45-1.17-.38S429.76,158.2,429.79,158.48Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.63,159.29a2.5,2.5,0,0,0,.81-.5.68.68,0,0,0-.06-1,2,2,0,0,0-1.64-.43,0,0,0,0,1,0-.06c.68-.12,1.77,0,2.17.63.52.86-.59,1.33-1.25,1.48C431.59,159.41,431.57,159.32,431.63,159.29Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.44,167.46c0,.28.39.49.85.48s.83-.25.82-.52-.39-.49-.85-.48S435.44,167.18,435.44,167.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.36,168.57a3.55,3.55,0,0,0,1.29-.64c.65-.7-.36-1.13-.91-1.29a0,0,0,0,1,0,0c.6,0,1.51.42,1.38,1.17s-1.13,1.06-1.76,1C436.3,168.7,436.3,168.6,436.36,168.57Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.64,164.46c-.05.21.2.44.55.51s.67,0,.71-.25-.2-.44-.55-.51S433.68,164.25,433.64,164.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.13,165.46a2.69,2.69,0,0,0,1.09-.26c.62-.41-.07-.92-.46-1.14,0,0,0,0,0,0,.45.15,1.07.58.84,1.13s-1,.6-1.49.41A.06.06,0,0,1,434.13,165.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.86,165.27c-.06.34.35.7.91.79s1.07-.09,1.13-.43-.35-.7-.92-.79S420.91,164.93,420.86,165.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.88,164.71s0,0,0,0c.54.4,1.28,1.06.75,1.78a1.6,1.6,0,0,1-2,.32c-.05,0,0-.11,0-.11a2.66,2.66,0,0,0,1.45-.18C424,166,423.38,165.16,422.88,164.71Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.7 46.55 452.22 46.55 452.22 299.59 421.24 299.59 442.86 170.84 398.7 46.55",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.7 46.55 452.22 46.55 452.22 299.59 421.24 299.59 442.86 170.84 398.7 46.55",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "407.97 53.4 416.92 82.69 425.72 112.03 443.32 170.7 443.35 170.8 443.33 170.9 435.02 232.26 430.86 262.95 426.55 293.61 430.39 262.88 434.39 232.18 442.39 170.77 442.41 170.97 425.12 112.2 416.48 82.82 407.97 53.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.03 58.59 449.26 83.96 449.4 109.34 449.51 160.09 449.4 210.85 449.26 236.22 449.03 261.6 448.8 236.22 448.67 210.85 448.56 160.09 448.67 109.34 448.8 83.96 449.03 58.59"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "439.03 63.34 441.15 90.29 443.17 117.24 447.08 171.16 447.08 171.18 447.08 171.2 445.12 231.29 444.04 261.33 442.86 291.37 443.56 261.32 444.36 231.27 446.15 171.17 446.15 171.22 442.47 117.29 440.71 90.32 439.03 63.34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432.07,287.48l3-29.16,3.09-29.15c2.14-19.43,4.2-38.86,6.41-58.28V171l-9.67-45.39-4.77-22.71-4.7-22.73,5.09,22.64,5,22.66,9.92,45.34V171c-2.1,19.43-4.35,38.84-6.52,58.27l-3.38,29.11Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 440.13,
    y: 168.71,
    width: 12.08,
    height: 5.9,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.62 46.55 313.11 46.55 313.11 299.59 344.08 299.59 322.46 170.84 366.62 46.55",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.62 46.55 313.11 46.55 313.11 299.59 344.08 299.59 322.46 170.84 366.62 46.55",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "357.35 53.4 348.41 82.69 339.6 112.03 322.01 170.7 321.98 170.8 321.99 170.9 330.31 232.26 334.47 262.95 338.78 293.61 334.93 262.88 330.93 232.18 322.93 170.77 322.91 170.97 340.21 112.2 348.85 82.82 357.35 53.4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.29 58.59 316.06 83.96 315.93 109.34 315.82 160.09 315.93 210.85 316.06 236.22 316.29 261.6 316.52 236.22 316.66 210.85 316.77 160.09 316.66 109.34 316.52 83.96 316.29 58.59"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.29 63.34 324.18 90.29 322.15 117.24 318.25 171.16 318.24 171.18 318.24 171.2 320.21 231.29 321.28 261.33 322.46 291.37 321.76 261.32 320.96 231.27 319.18 171.17 319.18 171.22 322.85 117.29 324.61 90.32 326.29 63.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.26,287.48l-3-29.16-3.08-29.15c-2.15-19.43-4.21-38.86-6.42-58.28V171l9.68-45.39,4.77-22.71,4.7-22.73-5.1,22.64-5,22.66-9.91,45.34,0,.07V171c2.1,19.43,4.35,38.84,6.52,58.27l3.38,29.11Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 313.11,
    y: 168.71,
    width: 12.09,
    height: 5.9,
    transform: "translate(638.3 343.32) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.79,252s-21.42-3-16.41-28.85C391.38,223.1,415.31,228.47,407.79,252Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.79,252s-21.42-3-16.41-28.85C391.38,223.1,415.31,228.47,407.79,252Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.71,246.55c-.42-1.3-.91-2.59-1.46-3.85,0-.17,0-.33-.05-.49l-.09-1.07c-.06-.77-.11-1.54-.16-2.31-.09-1.55-.19-3.09-.21-4.64a.07.07,0,0,0-.13,0c0,1.55,0,3.1,0,4.65,0,.77.08,1.54.13,2.31l0,.52a45.36,45.36,0,0,0-4.29-7.35c-.74-1-1.51-2-2.34-3s-1.76-1.9-2.62-2.87a.06.06,0,1,0-.09.09,39.41,39.41,0,0,1,4.13,5.49c.65,1,1.26,2,1.85,3l-.2-.07-.77-.31-1.74-.66-3.45-1.29c-.07,0-.12.1,0,.12,1.14.46,2.27.94,3.39,1.42l1.66.72.84.34a2.42,2.42,0,0,0,.57.2c.43.78.86,1.56,1.25,2.35a57.66,57.66,0,0,1,2.62,6.17l.15.45a12.8,12.8,0,0,0-1.75-.85l-2.22-1c-1.5-.69-3-1.39-4.43-2.2a.07.07,0,1,0-.07.11c1.48.8,2.92,1.66,4.39,2.46.74.4,1.48.79,2.23,1.16a7,7,0,0,0,2,.8,25.33,25.33,0,0,1,1.4,6.08c.24,2.92.21,5.87.28,8.8,0,.05.07.05.08,0,.21-2.66.33-5.35.34-8A23.06,23.06,0,0,0,406.71,246.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.41,231.35a24.8,24.8,0,0,0-.21,4.56,0,0,0,0,0,.06,0c.09-1.52.1-3,.28-4.53C403.55,231.3,403.42,231.27,403.41,231.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.29,232.64a16.79,16.79,0,0,1-2.76-1.35c-.07,0-.13.07-.06.11a10.31,10.31,0,0,0,2.78,1.33C397.3,232.75,397.34,232.66,397.29,232.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.48,293c0-2.37-.07-4.73-.09-7.1-.05-7.86-.11-15.72-.25-23.58Q408,253,407.7,243.6a.1.1,0,0,0-.05-.08l0-5.11s-.05-.06-.1-.06-.11,0-.11.06l0,5.12s-.05.05-.05.08c-.31,11.1-.59,22.21-.66,33.32,0,2.26,0,4.52,0,6.77q-.12,10.88-.08,21.73l0,3.46c0,6.63.07,13.25.07,19.88,0,.36.4.53.82.55s1-.17,1-.58c0-7.31.05-14.61.05-21.92C408.49,302.21,408.51,297.61,408.48,293Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.53,285.81s-10.3-7.63-20.08-2.47-11.31,25-11.31,25,14.36,2.06,23.4-6.55C400.25,293.53,399.53,285.81,399.53,285.81Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.53,285.81s-10.3-7.63-20.08-2.47-11.31,25-11.31,25,14.36,2.06,23.4-6.55C400.25,293.53,399.53,285.81,399.53,285.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.34,286.28a12.47,12.47,0,0,0-6-.78,8.81,8.81,0,0,0-1.26-.12l-1.45-.11c-1-.08-2-.14-3-.21-2-.15-4.07-.28-6.1-.48-.07,0-.08.12,0,.13,2,.25,4,.54,6,.74,1,.11,2.07.21,3.11.29l.75.07c-.31.07-.61.14-.91.23a24.21,24.21,0,0,0-4.67,1.9c-.81.14-1.62.37-2.41.56-1.28.3-2.55.63-3.82,1-2.5.65-5,1.39-7.46,2.11a.07.07,0,0,0,0,.13c2.48-.61,5-1.17,7.46-1.76l3.63-.87.94-.22a30.2,30.2,0,0,0-7.32,6.37,39.78,39.78,0,0,0-5.09,8c0,.07.07.14.11.07a39.17,39.17,0,0,1,6.16-8.09c-.05.14-.09.28-.14.41l-.57,1.82c-.38,1.22-.76,2.43-1.13,3.65,0,.08.1.11.13,0q.64-1.77,1.26-3.54l.61-1.74c.11-.3.21-.6.31-.91l.1-.27a37.13,37.13,0,0,1,3.65-3.12,28,28,0,0,1,5.47-3.13c0,.18-.06.36-.1.53-.1.47-.21.94-.3,1.41-.21,1-.4,1.95-.59,2.93-.38,2-.62,4-1,6,0,.09.11.12.13,0,.46-2,1.06-4,1.5-6,.23-1,.45-2,.66-3,.1-.47.19-.94.29-1.41.05-.27.11-.53.14-.79l.56-.23a16.3,16.3,0,0,1,8.57-1.18,8.45,8.45,0,0,1,6.21,5c.09.23.44.09.39-.14A8,8,0,0,0,402.34,286.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.57,294.77l-.87,3.92a27.23,27.23,0,0,0-.72,3.81c0,.05.07.05.08,0a29.66,29.66,0,0,0,.88-3.84l.75-3.87A.06.06,0,1,0,386.57,294.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.6,298.09c-1.31.67-2.58,1.42-4,2a.07.07,0,1,0,.05.12,40.59,40.59,0,0,0,3.93-2S376.64,298.07,376.6,298.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.85,271.79s-12.59.81-18.45-7.5-4.54-20.16-4.54-20.16,13.22,1.61,18.48,7.57S401.85,271.79,401.85,271.79Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.76,284.22c-.44-1.35-1-2.68-1.49-4s-1-2.53-1.56-3.78a80.84,80.84,0,0,0-3.78-7.42c-.89-1.53-1.84-3-2.82-4.47,0-.23-.06-.45-.1-.67-.06-.39-.11-.78-.17-1.17-.13-.8-.27-1.6-.4-2.39-.29-1.74-.65-3.47-.93-5.21,0-.08-.14-.08-.13,0,.26,1.72.43,3.45.67,5.17.12.85.23,1.69.36,2.53,0,.31.09.61.14.92a89.56,89.56,0,0,0-6.23-8.08c-.3-.35-.61-.69-.92-1,0-.1-.08-.19-.11-.29s-.19-.48-.28-.72l-.54-1.5c-.36-1-.67-2-.94-3a.07.07,0,0,0-.13,0c.26,1,.53,2.07.83,3.09.15.49.31,1,.48,1.46l.09.25c-1.61-1.76-3.29-3.45-5-5.12a.06.06,0,0,0-.09.09,90.89,90.89,0,0,1,8.92,10.93,7.89,7.89,0,0,0-.93-.23c-1-.19-2-.33-2.93-.45-2.05-.26-4.1-.52-6.14-.85-.08,0-.12.12,0,.13,1.95.39,3.88.83,5.82,1.27.91.21,1.83.39,2.75.57a18.07,18.07,0,0,1,2.21.63l.62.87q1.38,2,2.68,4.1l-1.29-.25c-1-.19-2-.36-2.92-.52-1.92-.32-3.85-.65-5.74-1.09-.09,0-.12.11,0,.13,1.93.45,3.84,1,5.75,1.49.92.25,1.85.47,2.78.68l1.4.3a4.28,4.28,0,0,0,.57.1q2.76,4.47,5.16,9.15,1,2.06,2,4.14c.67,1.43,1.24,2.89,1.87,4.34C407.4,284.65,407.86,284.53,407.76,284.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.87,255.28c-.24-1.2-.49-2.4-.76-3.6,0-.08-.14,0-.12,0,.23,1.18.46,2.36.67,3.55s.39,2.38.72,3.53a0,0,0,0,0,0,0A25.89,25.89,0,0,0,394.87,255.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.52,254.93c-.58-.29-1.2-.53-1.8-.76l-1-.38-.49-.19a2.11,2.11,0,0,1-.53-.24c-.09-.07-.15.1-.06.12a2.11,2.11,0,0,1,.54.22l.48.21.92.41a15.45,15.45,0,0,0,1.85.73A.07.07,0,0,0,387.52,254.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.74,261.89s7.62-14.23,19.21-16.44,18.69,9.73,18.69,9.73-8.46,10.8-19.1,12.68S414.74,261.89,414.74,261.89Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.72,251.83a31.47,31.47,0,0,0-9.09.11l.52-.28c.86-.43,1.71-.88,2.57-1.32,1.78-.93,3.58-1.91,5.44-2.66a.07.07,0,1,0-.05-.12c-1.82.85-3.7,1.55-5.52,2.39-.91.42-1.8.86-2.68,1.32-.58.31-1.21.59-1.77,1a32,32,0,0,0-7.37,2.44l1.45-1.57c1.08-1.19,2.14-2.43,3.33-3.51.06-.05,0-.14-.1-.09-1.21,1.11-2.49,2.13-3.67,3.27-.57.56-1.11,1.13-1.65,1.73-.26.29-.53.6-.78.91a30.54,30.54,0,0,0-15.54,21c0,.08.1.13.12,0A35.1,35.1,0,0,1,415.45,262,33.55,33.55,0,0,1,431,253a34.17,34.17,0,0,1,10.71-1A.12.12,0,0,0,441.72,251.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.64,255.18s-8.46,10.8-19.1,12.68c-8.11,1.44-14.79-2.79-17.5-4.88l-.58-1s5.48-4.62,15.87-7.29S452.64,255.18,452.64,255.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,246.76a27.33,27.33,0,0,0-2.58,1.7,17.24,17.24,0,0,0-2.23,2c-.06.07,0,.15.1.1.77-.67,1.54-1.34,2.34-2a23.61,23.61,0,0,1,2.44-1.76C435.13,246.83,435.06,246.71,435,246.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.35,249.17c-.43.18-.87.33-1.3.51l-1.29.54a.08.08,0,0,0,.05.15l1.29-.53c.43-.17.85-.37,1.29-.55C441.46,249.26,441.43,249.13,441.35,249.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.22,279.81s2,14.12,12.65,19.06,23.56,0,23.56,0S444.34,268.32,413.22,279.81Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.22,279.81s2,14.12,12.65,19.06,23.56,0,23.56,0S444.34,268.32,413.22,279.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.12,289.68c-1-.11-2-.28-2.93-.45l-1.42-.27-.75-.15c-.28-.27-.56-.54-.86-.8a43.48,43.48,0,0,0-6.49-4.71,38.59,38.59,0,0,0-3.89-2h.2l3.49.15c2.33.11,4.66.16,7,.31.09,0,.08-.12,0-.13-2.34-.16-4.67-.41-7-.61l-3.4-.3-1.74-.16-.45-.05c-.61-.22-1.22-.43-1.84-.63a16.57,16.57,0,0,0-9-.49c-2.67.68-5.34,2.43-6,5.25,0,.1.13.16.17.06,1-2.35,3.61-3.53,6-4a14.38,14.38,0,0,1,4.81-.1,10.81,10.81,0,0,0,.53,2.14c.3,1,.59,2,.89,3,.6,2,1.26,4,1.85,5.93a.06.06,0,0,0,.12,0c-.49-2-.91-4-1.38-6-.24-1-.48-1.95-.73-2.92a15.74,15.74,0,0,0-.53-2,23.54,23.54,0,0,1,2.76.65,40.83,40.83,0,0,1,4.81,1.76c.15,1,.38,2,.61,3,.29,1.25.61,2.48,1,3.7,0,.08.13,0,.12,0a1.55,1.55,0,0,1,0-.23h0c-.24-1.16-.5-2.31-.74-3.46-.2-.93-.38-1.86-.58-2.79a42.53,42.53,0,0,1,3.87,2c0,.28.1.58.14.84.08.49.16,1,.25,1.45.2,1.09.42,2.18.68,3.25a50.35,50.35,0,0,0,1.83,6.14s0,.06,0,.08l.06.07c0,.06.12,0,.11-.06-.5-2.09-1.06-4.17-1.52-6.27-.23-1.05-.46-2.1-.67-3.15l-.3-1.58c0-.15-.05-.31-.07-.47a43,43,0,0,1,4.13,2.76,44.44,44.44,0,0,1,6.33,5.77c.08.09.23,0,.16-.12a39.58,39.58,0,0,0-2.53-3.09c-.54-.57-1.09-1.13-1.66-1.67l.18,0c.5.09,1,.16,1.49.23,1,.13,2,.23,3,.34C442.17,289.82,442.2,289.69,442.12,289.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.65,294.47h0a2.38,2.38,0,0,0-.06-.37c0-.15-.1-.3-.12-.46h0c-.22-.95-.4-1.9-.57-2.85,0-.07-.12-.05-.12,0a11.62,11.62,0,0,0,.81,3.68s.08,0,.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.77,294.24s0-.06-.07-.06c-.29-1.25-.58-2.5-.84-3.76-.13-.66-.27-1.32-.4-2-.07-.36-.13-.72-.2-1.08a3.17,3.17,0,0,0-.22-.92s-.12,0-.12,0a6.18,6.18,0,0,0,.26,1.9c.13.69.27,1.38.42,2.06.31,1.39.65,2.78,1,4.15a.07.07,0,0,0,.14,0C425.78,294.45,425.77,294.34,425.77,294.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.15,285.61c-1.94-.26-3.88-.54-5.82-.78-.08,0-.12.12,0,.13,1.93.29,3.88.53,5.82.78C441.2,285.75,441.23,285.63,441.15,285.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.78,246.69s-6.5-28.51,24.13-40C431.91,206.65,440.39,244.17,407.78,246.69Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.39,230.52l.33-.2,1.73-1,3.55-2c2.34-1.31,4.64-2.67,7-4,.07,0,0-.15-.07-.11-2.36,1.28-4.76,2.48-7.13,3.74l-3.51,1.85-1.43.76c1-1.94,2.11-3.84,3.31-5.67,1.6-2.44,3.35-4.76,5.18-7a.1.1,0,0,0-.15-.14,48.49,48.49,0,0,0-7.08,8.68c0-.1,0-.2,0-.3q0-1.06.06-2.13c0-1.39-.05-2.78,0-4.17,0-.09-.12-.08-.13,0-.05,1.37-.22,2.74-.3,4.11,0,.68-.06,1.36-.08,2.05,0,.36-.05.79,0,1.19-.63,1-1.23,2-1.81,3.06a51.23,51.23,0,0,0-2.73,5.74c0-.72-.08-1.42-.12-2.13-.09-1.56-.28-3.12-.35-4.68a.07.07,0,0,0-.13,0c0,1.56,0,3.13,0,4.69,0,.78.05,1.56.1,2.34,0,.28,0,.58,0,.87a52.29,52.29,0,0,0-2.31,7.83,83.5,83.5,0,0,0-1.14,8.61,0,0,0,0,0,0,0,45.83,45.83,0,0,1,1.63-7.68c.38-1.34.78-2.68,1.21-4,1.27-.6,2.49-1.35,3.72-2s2.57-1.4,3.85-2.1c2.55-1.4,5.1-2.83,7.74-4.07.07,0,0-.14-.07-.11-2.67,1.21-5.36,2.36-8,3.68-1.31.65-2.59,1.35-3.86,2.07-1.07.6-2.16,1.2-3.18,1.89.3-.89.61-1.77.95-2.65Q412.64,234,414.39,230.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.81,224a.07.07,0,0,0-.14,0c.12,1.63.17,3.25.34,4.87,0,.09.15.09.15,0C412.1,227.25,411.93,225.63,411.81,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.49,229.45c-1.92.77-3.85,1.5-5.76,2.3-.05,0,0,.11,0,.09,1.93-.72,3.84-1.51,5.77-2.26C426.61,229.54,426.57,229.42,426.49,229.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.4,216.3a50.16,50.16,0,0,0-5.45,2.93c-.09.05,0,.19.09.13,1.78-1,3.58-2,5.43-3C429.54,216.38,429.47,216.27,429.4,216.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.77,
    y: 308.33,
    width: 44.17,
    height: 46.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.73,
    y: 324.8,
    width: 2.26,
    height: 79.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.48,
    y: 324.8,
    width: 2.26,
    height: 79.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.81,
    y: 324.8,
    width: 2.26,
    height: 79.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.86,
    y: 351.9,
    width: 47.75,
    height: 6.45,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-210"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "121.44 320.1 87.1 320.1 67.45 222.13 98.89 207.69 121.44 320.1",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.7 320.1 121.44 320.1 98.89 207.69 197.15 207.69 219.7 320.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.19,
    y: 267.54,
    width: 52.62,
    height: 107.96,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.95 375.5 230.58 375.5 209.16 267.54 244.95 267.54 244.95 375.5",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.81,
    y: 267.54,
    width: 28.91,
    height: 107.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.95,
    y: 267.54,
    width: 28.91,
    height: 107.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.72,
    y: 320.09,
    width: 112.23,
    height: 55.4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.72,
    y: 296.14,
    width: 112.23,
    height: 24.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.89,267.54l10.92-.15,10.91-.1H133v.26l.09,12.63,0,12.63c0,8.43,0,16.85,0,25.27s0,16.85-.11,25.27-.15,16.85-.28,25.27q-.21-12.63-.28-25.27c-.08-8.42-.09-16.84-.11-25.27s0-16.84,0-25.27l0-12.63.09-12.63.25.25-10.91-.11Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,267.54c.17,8.45.25,16.9.32,25.36l.09,25.36-.09,25.36-.12,12.68L245,369l-.2-12.68-.12-12.68-.09-25.36.1-25.36C244.7,284.44,244.78,276,245,267.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,320.09c-9.35.17-18.7.25-28.06.32l-28,.1-28.06-.1-14-.11-14-.21,14-.2,14-.11,28.06-.1,28,.1C226.25,319.84,235.6,319.92,245,320.09Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,296.14c-9.35.17-18.7.25-28.06.32l-28,.1-28.06-.1-14-.11-14-.21,14-.2,14-.11,28.06-.1,28,.1C226.25,295.89,235.6,296,245,296.14Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.19 375.49 70.48 384.24 68.81 404.45 61.2 404.45 59.53 384.24 58.82 375.49 71.19 375.49",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.82 375.49 71.19 375.49 70.48 384.24 59.53 384.24 58.82 375.49",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.45 375.49 123.73 384.24 122.07 404.45 114.45 404.45 112.79 384.24 112.08 375.49 124.45 375.49",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.08 375.49 124.45 375.49 123.73 384.24 112.79 384.24 112.08 375.49",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.78 375.49 212.07 384.24 210.41 404.45 202.79 404.45 201.13 384.24 200.42 375.49 212.78 375.49",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.42 375.49 212.78 375.49 212.07 384.24 201.13 384.24 200.42 375.49",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.05 375.49 265.34 384.24 263.68 404.45 256.06 404.45 254.4 384.24 253.69 375.49 266.05 375.49",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.05 375.49 265.34 384.24 254.4 384.24 253.69 375.49 266.05 375.49",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25,384.91c-2.44-.9-57.72-45.08-58.77-48.1-.4-1.14,5.57-9.57,13.06-19.54,1.62-2.16,3.3-4.37,5-6.61,11.17-14.56,23.36-29.74,23.36-29.74L282,310.36l-24.39,28.93-5.35,6.36s13.6,26.38,14.39,29.81S264.7,385.8,262.25,384.91Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25,384.91c-2.44-.9-57.72-45.08-58.77-48.1-.48-1.39,8.42-13.54,18.09-26.15l36,28.63-5.35,6.36s13.6,26.38,14.39,29.81S264.7,385.8,262.25,384.91Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.52,313.11a3.59,3.59,0,0,1-.68,1.3,3.75,3.75,0,0,1-1.11,1,3.58,3.58,0,0,1,.69-1.31A3.7,3.7,0,0,1,221.52,313.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.28,314.49a3.91,3.91,0,0,1-.69,1.31,3.87,3.87,0,0,1-1.11,1,4.13,4.13,0,0,1,1.8-2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,315.87a3.91,3.91,0,0,1-.69,1.31,3.87,3.87,0,0,1-1.11,1,3.77,3.77,0,0,1,.69-1.3A4.05,4.05,0,0,1,225,315.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.78,317.26a3.77,3.77,0,0,1-.69,1.3,3.63,3.63,0,0,1-1.11,1,3.91,3.91,0,0,1,.69-1.31A3.87,3.87,0,0,1,226.78,317.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.53,318.64a3.74,3.74,0,0,1-.69,1.31,3.62,3.62,0,0,1-1.11,1,3.91,3.91,0,0,1,.69-1.31A3.87,3.87,0,0,1,228.53,318.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.28,320a3.58,3.58,0,0,1-.69,1.31,3.7,3.7,0,0,1-1.1,1,3.46,3.46,0,0,1,.69-1.3A3.59,3.59,0,0,1,230.28,320Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,321.41a4,4,0,0,1-.69,1.3,3.87,3.87,0,0,1-1.11,1,3.62,3.62,0,0,1,.69-1.3A3.74,3.74,0,0,1,232,321.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.79,322.79a4.13,4.13,0,0,1-1.8,2.28,3.74,3.74,0,0,1,.69-1.31A3.87,3.87,0,0,1,233.79,322.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.54,324.17a3.91,3.91,0,0,1-.69,1.31,3.74,3.74,0,0,1-1.11,1,4.13,4.13,0,0,1,1.8-2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.29,325.55a3.74,3.74,0,0,1-.69,1.31,3.62,3.62,0,0,1-1.11,1,4.13,4.13,0,0,1,1.8-2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,326.94a3.46,3.46,0,0,1-.69,1.3,3.59,3.59,0,0,1-1.1,1,3.58,3.58,0,0,1,.69-1.31A3.7,3.7,0,0,1,239,326.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8,328.32a4.13,4.13,0,0,1-1.8,2.28,3.58,3.58,0,0,1,.69-1.31A3.74,3.74,0,0,1,240.8,328.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.55,329.7a3.91,3.91,0,0,1-.69,1.31,3.87,3.87,0,0,1-1.11,1,3.61,3.61,0,0,1,.69-1.3A3.75,3.75,0,0,1,242.55,329.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,331.08a3.91,3.91,0,0,1-.69,1.31,3.74,3.74,0,0,1-1.11,1,3.77,3.77,0,0,1,.69-1.3A4.05,4.05,0,0,1,244.3,331.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,332.47a3.61,3.61,0,0,1-.69,1.3,3.52,3.52,0,0,1-1.11,1,3.91,3.91,0,0,1,.69-1.31A3.87,3.87,0,0,1,246.05,332.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8,333.85a3.58,3.58,0,0,1-.69,1.31,3.7,3.7,0,0,1-1.1,1,3.72,3.72,0,0,1,.68-1.31A3.87,3.87,0,0,1,247.8,333.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.56,335.23a3.91,3.91,0,0,1-.69,1.31,3.87,3.87,0,0,1-1.11,1,3.46,3.46,0,0,1,.69-1.3A3.63,3.63,0,0,1,249.56,335.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.31,336.62a4,4,0,0,1-.69,1.3,3.75,3.75,0,0,1-1.11,1,4,4,0,0,1,1.8-2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.06,338a3.77,3.77,0,0,1-.69,1.3,3.63,3.63,0,0,1-1.11,1A3.91,3.91,0,0,1,252,339,3.87,3.87,0,0,1,253.06,338Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.81,339.38a4,4,0,0,1-1.8,2.28,4.13,4.13,0,0,1,1.8-2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.11,366.24a16.28,16.28,0,0,0-10.47-2.11,11.86,11.86,0,0,0-4.66,1.8,9.78,9.78,0,0,0-1.78,1.49c-.31.34-1.06,1-.81,1.52,0,.06.13.06.14,0,.08-.35.55-.67.82-.89s.63-.48,1-.69a12.56,12.56,0,0,1,1.88-1,13.65,13.65,0,0,1,4.35-1.14,26.46,26.46,0,0,1,9.51,1.2C262.14,366.43,262.21,366.29,262.11,366.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.87,336.15a14.33,14.33,0,0,0-4.46-7.13A9.71,9.71,0,0,0,211,327.4a.08.08,0,0,0-.09.13c.65.62,1.35,1.15,2,1.81a18.38,18.38,0,0,1,1.74,2.19,16.32,16.32,0,0,1,2.14,4.87,15.76,15.76,0,0,1-.82,10.36c-.1.21.19.41.31.2A14.53,14.53,0,0,0,217.87,336.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.44,253.74C316.9,273,269.44,328.59,264,335l-1.24,1.45-39.26-30.16.45-.59,34.57-45.26-103.11-.6,39.15-30.45s3.17,1.84,9.78.87c22.75-3.33,74.06-10.7,86.16-10.21C306.05,220.65,321.77,236.07,319.44,253.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.89,243.58a44.11,44.11,0,0,0-3.57,4.57c-1.22,1.6-2.46,3.19-3.68,4.79l0,.05.65-1.41c.77-1.59,1.39-3.24,2.3-4.77.06-.09-.09-.18-.14-.09-.94,1.52-2,3-2.83,4.55-.37.75-.73,1.51-1.06,2.28-.19.42-.37.85-.54,1.28-.07.19-.16.4-.22.61-.55.75-1.09,1.49-1.61,2.25-1.17,1.69-2.19,3.47-3.37,5.15-.06.09.08.17.14.08,1.2-1.57,2.53-3,3.75-4.6s2.4-3.22,3.55-4.86,2.24-3.23,3.36-4.84a47.32,47.32,0,0,0,3.4-5C271,243.59,270.94,243.52,270.89,243.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,180.68c4.07,9.44,25,45.82,35,47.75,6.61,1.27,33.92.82,38.34-5.57,1.92-2.79-2.72-24.57-6.25-23.72s-24.74,4.17-27.38,3.48-24.63-25-32.08-30.39C173.81,162.88,176.81,175.6,179,180.68Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.77,198.94l3.94,30.31s-19.93,3.92-27.06-.5S186,197.13,179.34,181.27s-.91-18.65,10.25-7.44,27.24,27.39,29.28,27.25S233.77,198.94,233.77,198.94Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.3,223.34a12.46,12.46,0,0,0-1.77-2.82,12.83,12.83,0,0,0,2.75,6A11.68,11.68,0,0,0,227.3,223.34ZM195.68,203a11.94,11.94,0,0,0-1.76-2.83,11.83,11.83,0,0,0,1,3.19,11.66,11.66,0,0,0,1.77,2.83A11.08,11.08,0,0,0,195.68,203Zm8.4-14.78A12.05,12.05,0,0,0,201.4,190a11.91,11.91,0,0,0,3.18-1l.15-.07Zm10.45,20.49a11.54,11.54,0,0,0-.74,3.26,12.47,12.47,0,0,0,1.56-2.95,11.9,11.9,0,0,0,.73-3.25A12,12,0,0,0,214.53,208.74Zm-28.08-27.61a12.54,12.54,0,0,0-3.24-.75,10.79,10.79,0,0,0,2.94,1.55,11.92,11.92,0,0,0,3.26.76A11.67,11.67,0,0,0,186.45,181.13Zm48,23.12a12.18,12.18,0,0,0-2.8-1.44,12.32,12.32,0,0,0-3.25-.76,11.11,11.11,0,0,0,2.94,1.56,12.57,12.57,0,0,0,3.12.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.47,202c.76,7,1.81,14,2.87,21,.3,2,.62,3.94.89,5.92,0,.07.12.06.11,0-.38-3.51-.66-7-1.08-10.55s-.93-7-1.51-10.5c-.33-2-.65-3.94-1-5.9A.13.13,0,0,0,226.47,202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,230.83c-4.77.11-9.55-.34-12.35-2.08-7.12-4.42-24.66-31.62-31.3-47.48-3-7.2-3.49-11.71-2-13.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.78,256.93c-.23,0,64.13-10.91,64.7-11.63.26-.33,1-7.37-.5-16.71-3.19-19.82-13-51.59-20.64-61.22-2.82-3.54-11.91-3.42-16,.07-13.47,11.45-27.6,54.31-29.74,73.21C132.5,250.26,136.58,257,135.78,256.93Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,212a12.3,12.3,0,0,0-3.25-.75,11.23,11.23,0,0,0,2.94,1.55,12.3,12.3,0,0,0,3.26.76A11.47,11.47,0,0,0,160.78,212Zm25.84-30.79-.17-.07a12.54,12.54,0,0,0-3.24-.75,10.79,10.79,0,0,0,2.94,1.55c.29.11.58.21.88.3C186.89,181.88,186.75,181.54,186.62,181.2Zm-8.39,67.46a11.88,11.88,0,0,0-3.26-.73,11.75,11.75,0,0,0,2.95,1.55l.25.09,1.5-.26C179.2,249.06,178.71,248.86,178.23,248.66Zm20.09-28.77a9.47,9.47,0,0,0-1.33-.18,9.37,9.37,0,0,0,1.49.92C198.43,220.39,198.38,220.14,198.32,219.89ZM147.2,248.66a11.9,11.9,0,0,0-3.25-.73,11.69,11.69,0,0,0,2.94,1.55,12.21,12.21,0,0,0,3.26.76A11.86,11.86,0,0,0,147.2,248.66ZM163,235.49a11.24,11.24,0,0,0-.74,3.25,11.67,11.67,0,0,0,1.56-3,11.94,11.94,0,0,0,.73-3.24A12.08,12.08,0,0,0,163,235.49Zm11.54-37.63a11.54,11.54,0,0,0-.74,3.26,12.47,12.47,0,0,0,1.56-3,11.9,11.9,0,0,0,.73-3.25A12.2,12.2,0,0,0,174.56,197.86Zm14.17,37.32A11.66,11.66,0,0,0,185.9,237a10.92,10.92,0,0,0,3.18-1,11.62,11.62,0,0,0,2.83-1.76A11.63,11.63,0,0,0,188.73,235.18Zm-42.16-6.33a12.28,12.28,0,0,0-2.84,1.78,12.09,12.09,0,0,0,3.19-1,11.66,11.66,0,0,0,2.83-1.77A11.65,11.65,0,0,0,146.57,228.85Zm7.92-37.28a12,12,0,0,0-2.83,1.78,11.91,11.91,0,0,0,3.18-1,11.47,11.47,0,0,0,2.83-1.77A11.87,11.87,0,0,0,154.49,191.57Zm-11.39,15.2c-.16-.35-.34-.69-.53-1-.13.36-.26.72-.38,1.08l.13.3a11.68,11.68,0,0,0,1.76,2.84A11.59,11.59,0,0,0,143.1,206.77ZM182,218.07a12.23,12.23,0,0,0-1.76-2.81,12.86,12.86,0,0,0,2.75,6A11.91,11.91,0,0,0,182,218.07Zm-15.51-39.72a11.36,11.36,0,0,0-1.77-2.83,11.56,11.56,0,0,0,1,3.18,12.59,12.59,0,0,0,1.77,2.84A11.28,11.28,0,0,0,166.51,178.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.56,322.47c-.9,2.44-45.26,57.58-48.28,58.62-1.14.39-9.55-5.6-19.5-13.13-2.15-1.62-4.36-3.31-6.6-5-14.52-11.22-29.66-23.47-29.66-23.47l29.56-37L359.93,327l6.34,5.37S392.7,318.82,396.13,318,406.47,320,405.56,322.47Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.56,322.47c-.9,2.44-45.26,57.58-48.28,58.62-1.4.47-13.52-8.47-26.1-18.17l28.75-36,6.34,5.37S392.7,318.82,396.13,318,406.47,320,405.56,322.47Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.13,363.17a3.76,3.76,0,0,1,1.32.68,3.69,3.69,0,0,1,1,1.09,3.54,3.54,0,0,1-1.31-.67A3.76,3.76,0,0,1,334.13,363.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.49,361.4a3.76,3.76,0,0,1,1.32.68,3.69,3.69,0,0,1,1,1.09,3.54,3.54,0,0,1-1.31-.67A3.76,3.76,0,0,1,335.49,361.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.85,359.64a3.74,3.74,0,0,1,1.32.67,3.69,3.69,0,0,1,1,1.09,3.54,3.54,0,0,1-1.31-.67A3.72,3.72,0,0,1,336.85,359.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.21,357.87a3.74,3.74,0,0,1,1.32.67,3.61,3.61,0,0,1,1,1.1,4.18,4.18,0,0,1-2.3-1.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.57,356.1a3.74,3.74,0,0,1,1.32.67,3.61,3.61,0,0,1,1,1.1,4.18,4.18,0,0,1-2.3-1.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.93,354.33a4,4,0,0,1,2.3,1.77,4.18,4.18,0,0,1-2.3-1.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.29,352.56a4,4,0,0,1,2.3,1.77,4.18,4.18,0,0,1-2.3-1.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.65,350.79a4,4,0,0,1,2.3,1.77,4.18,4.18,0,0,1-2.3-1.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,349a4,4,0,0,1,2.3,1.77A4.18,4.18,0,0,1,345,349Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.37,347.25a4,4,0,0,1,2.3,1.77,4.18,4.18,0,0,1-2.3-1.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,345.48a4,4,0,0,1,2.3,1.77,4.06,4.06,0,0,1-2.3-1.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.09,343.71a4,4,0,0,1,2.31,1.77,3.83,3.83,0,0,1-1.32-.67A3.89,3.89,0,0,1,349.09,343.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.45,341.94a4,4,0,0,1,2.31,1.77,3.83,3.83,0,0,1-1.32-.67A3.89,3.89,0,0,1,350.45,341.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.81,340.17a3.92,3.92,0,0,1,1.32.67,4,4,0,0,1,1,1.1,3.83,3.83,0,0,1-1.32-.67A3.89,3.89,0,0,1,351.81,340.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.17,338.4a3.92,3.92,0,0,1,1.32.67,4,4,0,0,1,1,1.1,3.83,3.83,0,0,1-1.32-.67A3.89,3.89,0,0,1,353.17,338.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.53,336.63a3.92,3.92,0,0,1,1.32.67,4,4,0,0,1,1,1.1,3.83,3.83,0,0,1-1.32-.67A3.89,3.89,0,0,1,354.53,336.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.89,334.86a3.92,3.92,0,0,1,1.32.67,4,4,0,0,1,1,1.1,3.83,3.83,0,0,1-1.32-.67A3.89,3.89,0,0,1,355.89,334.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.25,333.09a3.92,3.92,0,0,1,1.32.67,4,4,0,0,1,1,1.1,3.66,3.66,0,0,1-1.32-.67A3.89,3.89,0,0,1,357.25,333.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.61,331.32a4,4,0,0,1,2.31,1.77,3.66,3.66,0,0,1-1.32-.67A3.89,3.89,0,0,1,358.61,331.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,329.55a4,4,0,0,1,2.31,1.77,3.66,3.66,0,0,1-1.32-.67A3.76,3.76,0,0,1,360,329.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.73,323.36a16.38,16.38,0,0,0-2,10.5,12,12,0,0,0,1.86,4.64,9.69,9.69,0,0,0,1.51,1.75c.35.31,1,1.06,1.54.8a.08.08,0,0,0,0-.15c-.35-.07-.68-.54-.9-.81a10.91,10.91,0,0,1-.7-.94,13.51,13.51,0,0,1-1-1.86,13.68,13.68,0,0,1-1.19-4.33,26.51,26.51,0,0,1,1.07-9.53A.09.09,0,0,0,386.73,323.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.22,366.53a14.18,14.18,0,0,0-5.09,2.62,14.52,14.52,0,0,0-2,1.93,9.72,9.72,0,0,0-1.58,2.44c0,.07.08.14.13.08.61-.65,1.13-1.36,1.79-2a16.6,16.6,0,0,1,2.16-1.76,16.33,16.33,0,0,1,4.84-2.21,15.78,15.78,0,0,1,10.37.69c.21.1.41-.2.2-.32A14.59,14.59,0,0,0,357.22,366.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.39,321.39,327.62,362.9l-103.82-72-10-7s-2.84,1.91-7.1,4.27c-5.93,3.28-14.62,7.43-22.3,8.56-12.89,1.91-32.33,1.7-43.19-12.83-9.15-12.23-6.26-28.19-6.26-28.19l14.15-6.07s33.49-27.91,55.18-28.75c9.22-.37,22.63,6.62,35.06,13.91S358.39,321.39,358.39,321.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.79,283.9s-2.84,1.91-7.1,4.27c-7.55-9-23.52-25.43-24-26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.36,240.3c-2,1.39-3.94,2.86-5.91,4.29s-3.95,2.72-5.8,4.25-3.66,3.23-5.43,4.91c-.85.81-1.7,1.62-2.52,2.46a22.08,22.08,0,0,0-2.41,2.62c-.07.09.06.19.14.14a26.69,26.69,0,0,0,2.69-2.18l2.79-2.39c1.8-1.53,3.64-3,5.44-4.55s3.43-3.19,5.2-4.74,3.88-3.19,5.85-4.75C161.44,240.33,161.4,240.27,161.36,240.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,319.9c-2,2.15-3.85,4.47-5.71,6.75s-3.73,4.57-5.57,6.88c-3.69,4.6-7.41,9.19-11,13.85-2,2.56-4,5.14-5.81,7.81-.08.12.11.25.2.14,4-4.36,7.6-9,11.28-13.62s7.37-9.24,11-13.91c2-2.56,4-5.1,5.84-7.77A.11.11,0,0,0,351.17,319.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.35,324.42c-5.17-4.07-16.91-12-22.27-15.83S239.43,301,234,297.29c-1.55-1.05-3.12-2.09-4.68-3.13s-3.19-2-4.72-3.08c-.09-.06-.17.09-.08.15,1.4,1,2.73,2.14,4.11,3.18s2.63,2,4,3c2.59,1.92,5.21,3.8,7.82,5.69q8,5.76,16.05,11.33c3.07,2.1,12.5,8.31,15.64,10.31C272.3,324.86,272.53,324.56,272.35,324.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.93,281.53c-4.78-3.95-15.66-11.56-20.66-15.21s-10.1-7.44-15.18-11.11L254,244.28c-4.88-3.53-9.75-7.12-14.91-10.25-2.82-1.71-5.72-3.3-8.7-4.73a56.15,56.15,0,0,0-9-3.67c-.09,0-.14.11-.06.16,2.55,1.42,5.22,2.61,7.79,4s5.05,2.78,7.52,4.28c5.12,3.1,10,6.63,14.82,10.13,10.09,7.26,20.16,14.54,30.33,21.7,5.69,4,17,12.28,22.93,16C304.89,282,305.1,281.67,304.93,281.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.93,222.44c-2.51-2.11,3.86-21.83,7-23,.59-.22,1.46-.51,3.37-1.36h0a47.71,47.71,0,0,0,11.76-7.48c4.09-3.78,9.73-9.87,11.84-7.74,3.1,3.08-3.11,11.64-7,16.33,3.25.57,6,1.38,7.43,2.43,4.74,3.5-8.19,26.65-14.18,26.89C251.43,228.72,239.44,224.56,236.93,222.44Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.1,222.54c-.27-2-2.13-11.88-10-12.55-9.81-.85-12.87,6.06-17.8,8.53-9.63,4.84-29.3-4.74-44,6.06S129,254.67,134.64,266s18.25,26.92,33.5,23c14.8-3.76,17.78-16.85,25-21.65,6.58-4.38,27.54-7.42,29-16.52,1-6.07-5.58-4.69-7.63-7.52s.35-5.73.55-7.26C215.53,232.59,211.1,222.54,211.1,222.54Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.1,222.54c-.27-2-2.13-11.88-10-12.55-9.81-.85-12.87,6.06-17.8,8.53-9.63,4.84-29.3-4.74-44,6.06S129,254.67,134.64,266s18.25,26.92,33.5,23c14.8-3.76,17.78-16.85,25-21.65,6.58-4.38,27.54-7.42,29-16.52,1-6.07-5.58-4.69-7.63-7.52s.35-5.73.55-7.26C215.53,232.59,211.1,222.54,211.1,222.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.53,251.29l9.08-5s4.47,2.78,9.21.64,5.39-7.46,5.39-7.46l2.1-.92A9.94,9.94,0,0,1,207,243.8c.29,6.12-10.35,21.54-21,19C177.71,260.87,179.53,251.29,179.53,251.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.96,
    cy: 238.46,
    r: 9.82,
    transform: "translate(-60.68 66.3) rotate(-16.81)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.96,
    cy: 238.46,
    r: 7.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.05 187.49 291.51 194.37 203.23 241.6 196.98 229.15 288.05 187.49",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.46,
    y: 248.7,
    width: 16.15,
    height: 4.26,
    transform: "translate(317.04 -12.35) rotate(63.33)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.85,
    y: 179.09,
    width: 1.17,
    height: 3.14,
    transform: "translate(633.85 198.75) rotate(151.23)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.51,
    y: 177.32,
    width: 2.35,
    height: 3.92,
    transform: "translate(307.95 -161.8) rotate(61.23)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.84,
    y: 176.37,
    width: 1.17,
    height: 3.14,
    transform: "translate(641.91 191.29) rotate(151.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.5,
    y: 174.61,
    width: 2.35,
    height: 3.92,
    transform: "translate(308.14 -167.59) rotate(61.23)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.84,
    y: 173.65,
    width: 1.17,
    height: 3.14,
    transform: "translate(649.97 183.77) rotate(151.23)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.49,
    y: 171.89,
    width: 2.35,
    height: 3.92,
    transform: "translate(308.34 -173.38) rotate(61.23)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.54,
    y: 194.44,
    width: 1.17,
    height: 3.14,
    transform: "translate(642.8 288.24) rotate(161.66)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.45,
    y: 195.54,
    width: 2.35,
    height: 3.92,
    transform: "translate(205.15 543.11) rotate(-108.34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.93,
    y: 192.63,
    width: 1.17,
    height: 3.14,
    transform: "translate(652.72 283.06) rotate(161.66)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.84,
    y: 193.73,
    width: 2.35,
    height: 3.92,
    transform: "translate(213.93 545.84) rotate(-108.34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.32,
    y: 190.82,
    width: 1.17,
    height: 3.14,
    transform: "translate(662.65 277.83) rotate(161.66)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.23,
    y: 191.92,
    width: 2.35,
    height: 3.92,
    transform: "translate(222.76 548.58) rotate(-108.35)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.67,184.29l-3.39-7.76s-2.61.73-6.22-2.09l-15.82,8.25-2.07,3.47,4,9.24,3.95.85,16.81-6C312.35,185.7,314.67,184.29,314.67,184.29Zm-22.49,3.07-.81-1.86L306.31,179l.81,1.86Zm2.36,5.41-.82-1.87,14.94-6.52.82,1.88Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.87,246.28l16.25-7.84,16.29-7.76L224,218.16l32.67-15.35c10.9-5.11,21.77-10.25,32.7-15.28l0,0,2.57-6.26-2.47,6.3v0h0c-10.82,5.25-21.7,10.4-32.56,15.57l-32.6,15.5L196.58,231l-16.34,7.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,248.55l16.28-8,16.31-7.91,27.64-12.8c10.88-5.26,21.8-10.43,32.7-15.66s21.8-10.45,32.74-15.59l0,0,6-9.81-5.86,9.9v0h0c-10.84,5.35-21.75,10.56-32.62,15.84s-21.74,10.57-32.65,15.78L197.76,233l-16.36,7.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.7,176.32l-11.14,13.27,0,0h0L259,205.75c-10.87,5.36-21.69,10.78-32.58,16.08l-27.65,12.95-16.32,8-16.36,7.9,16.24-8.14,16.27-8.07,27.56-13.12c10.85-5.39,21.76-10.66,32.63-16l32.65-15.94,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.13,252.9l16.2-8.32,16.23-8.26L227,222.83c10.81-5.52,21.69-10.91,32.54-16.37l32.57-16.31h.06l16.33.72-16.34-.48h.06l-32.47,16.51c-10.83,5.48-21.63,11-32.49,16.46l-27.56,13.32-16.29,8.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.27,193.15,292,191.47H292c-10.67,5.66-21.41,11.19-32.11,16.79L227.74,225l-27.21,13.58-16.12,8.28L168.26,255l16-8.45,16.06-8.38,27.14-13.75,32.2-16.6c10.75-5.51,21.46-11.09,32.24-16.54H292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.36,257.22l15.9-8.51,15.93-8.43,26.88-13.85,32-16.7c10.66-5.56,21.31-11.14,32-16.62h.05l6.06,2.39L292,193.2h0c-10.58,5.7-21.22,11.29-31.85,16.91L228.35,227l-27,13.68-16,8.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,197.67c-2.56,1.69.89,3.74.89,3.74s-5.68-1.76-7.64,1,2.37,5,2.67,5.16c-.3-.09-5.56-1.56-7.25,1.41s2.92,4.7,3.22,4.8c-.31,0-4.42.13-5.19,2.68-1.32,4.39,9.2,4.35,11.72,7.08,0,0-4.13,4.79-4.22,5,0,0,10,.18,13.5-3.42a3.2,3.2,0,0,0,.43-4s3.22.41,4.62-1.89c.72-1.18-.53-3.38-.53-3.38a4,4,0,0,0,3.71-1.9c.9-1.69-.5-3.64-.5-3.64s2.59-.94,2.95-3C282.11,203.23,268.47,194.07,263,197.67Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.26,209.94a0,0,0,1,0,.06-.06,28.45,28.45,0,0,0-14.61-8.6c-.18,0-.31.23-.12.31A58.58,58.58,0,0,1,278.26,209.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,215.84c.05,0,.12-.05.07-.1a26.66,26.66,0,0,0-16.51-8.39c-.23,0-.45.18-.19.22C262.94,208.27,271.16,212.51,275.3,215.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.43,213.9c6.18.78,11.49,3.46,16.55,7,.06,0,.12-.05.08-.1-2-2.41-5.46-4.33-8.28-5.6a16.5,16.5,0,0,0-8.32-1.52C254.34,213.69,254.3,213.88,254.43,213.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.85,201.31c-.22,0-.05.32-.26.28-.92-.16-6.5-.64-7.25,1.21-.6,1.49,1,3.32,1.86,3.79l2.22,1.18-2.5-.34a10.56,10.56,0,0,0-3.32.07,3.72,3.72,0,0,0-2.57,1.57,2.11,2.11,0,0,0,.24,2.63,6.38,6.38,0,0,0,2.75,1.6l2.84.9-3,.08a9.68,9.68,0,0,0-2.44.37,4,4,0,0,0-2,1.17,1.88,1.88,0,0,0-.29,2,4.1,4.1,0,0,0,1.74,1.56,32.6,32.6,0,0,0,4.79,1.93c.82.29,1.64.58,2.45.91a6.11,6.11,0,0,1,2.24,1.35,6.49,6.49,0,0,0-2.32-1.12c-.83-.27-1.66-.49-2.5-.72a27.76,27.76,0,0,1-5-1.71,5,5,0,0,1-2.16-1.81,2.68,2.68,0,0,1,.32-2.92,4.84,4.84,0,0,1,2.41-1.52,10.76,10.76,0,0,1,2.71-.46l-.13,1a7.28,7.28,0,0,1-3.27-1.86,3.08,3.08,0,0,1-.84-1.88,3.4,3.4,0,0,1,.52-2,4.63,4.63,0,0,1,3.24-2,11.24,11.24,0,0,1,3.66,0l-.27.84c-1.1-.63-3.09-2.49-2.45-4.91C256.66,199.46,262.75,201,263.85,201.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.89,201.41A5.88,5.88,0,0,1,262.7,200a1.43,1.43,0,0,1-.05-1.44,3,3,0,0,1,1.32-1c.57-.24,1.18-.47,1.82-.67a4.8,4.8,0,0,0-2,0,2.85,2.85,0,0,0-1.84,1.18,2,2,0,0,0-.25,1.19,2.15,2.15,0,0,0,.47,1A3.34,3.34,0,0,0,263.89,201.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2,173.24c-17,18.19-36,41.09-31,49.89s24.88,26.09,39.47,32.1c3.09,1.27,15.45-26.92,12.07-28.1-8.82-3.09-24.15-15.48-25.13-17.15-.47-.8,10.41-18.26,15.44-31.42C174.1,162.66,167.34,162.35,157.2,173.24Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.41,246.24c-2.12,2.54-3.1,2.47-3.1,2.47a6.11,6.11,0,0,1-.24,4.15c-1.1,2.26-5.13,1.52-5.13,1.52a7.51,7.51,0,0,1-1,4.33c-1.27,2.06-5.44,1.9-5.44,1.9a6.63,6.63,0,0,1-3.24,3.28c-3.92,1.63-22.55-8-27.22-11.57l15.26-25.76s20,3.34,23.64,6.66C203,236,209.65,242.35,206.41,246.24Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.32,248.59c-2.49-3.75-5.88-6.89-9.19-9.89-.07-.07-.17.05-.1.12,3.32,2.94,5.93,6.84,9.13,9.91C203.25,248.82,203.39,248.69,203.32,248.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,254.05a11.75,11.75,0,0,0-2.23-2.11c-.84-.69-1.7-1.36-2.56-2-1.73-1.32-3.49-2.61-5.28-3.84-.08-.06-.19.05-.11.11,1.73,1.33,3.43,2.68,5.09,4.07l2.48,2.12a13.81,13.81,0,0,0,2.41,1.9A.15.15,0,0,0,198.06,254.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.47,260.55a8.34,8.34,0,0,0-2.12-1.79c-.8-.58-1.59-1.18-2.39-1.77-1.58-1.2-3.17-2.39-4.71-3.64a.08.08,0,0,0-.11.12c1.57,1.27,3.11,2.57,4.69,3.83.77.62,1.54,1.24,2.32,1.85a7.75,7.75,0,0,0,2.26,1.48C191.46,260.65,191.49,260.59,191.47,260.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.34,223.29l-15.42,29.5s-31.37-22.75-32.06-32,16-32.38,31.39-47.72,16.43-6.48,11.75,7.34-14,28.13-14.06,29.08S172.34,223.29,172.34,223.29Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.51,178.35a11.36,11.36,0,0,0-1.77-2.83,11.56,11.56,0,0,0,1,3.18,12.59,12.59,0,0,0,1.77,2.84A11.28,11.28,0,0,0,166.51,178.35ZM143.1,206.77a12,12,0,0,0-1.77-2.83,11.56,11.56,0,0,0,1,3.18,11.68,11.68,0,0,0,1.76,2.84A11.59,11.59,0,0,0,143.1,206.77Zm11.39-15.2a12,12,0,0,0-2.83,1.78,11.91,11.91,0,0,0,3.18-1,11.47,11.47,0,0,0,2.83-1.77A11.87,11.87,0,0,0,154.49,191.57Zm-7.92,37.28a12.28,12.28,0,0,0-2.84,1.78,12.09,12.09,0,0,0,3.19-1,11.66,11.66,0,0,0,2.83-1.77A11.65,11.65,0,0,0,146.57,228.85Zm-16.07-7a11.54,11.54,0,0,0-.74,3.26,12.47,12.47,0,0,0,1.56-3,11.9,11.9,0,0,0,.73-3.25A12.2,12.2,0,0,0,130.5,221.86ZM163,235.49a11.24,11.24,0,0,0-.74,3.25,11.67,11.67,0,0,0,1.56-3,11.94,11.94,0,0,0,.73-3.24A12.08,12.08,0,0,0,163,235.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.52,221.58c-3.55,6.36-6.83,12.87-10.11,19.38-.92,1.84-1.82,3.69-2.78,5.51,0,.07.07.12.1.06,1.77-3.18,3.63-6.31,5.36-9.52s3.4-6.45,5-9.73c.9-1.85,1.81-3.7,2.65-5.58C166.79,221.56,166.6,221.43,166.52,221.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35,187.42q-.82,1.19-1.68,2.37c-.23.32-.47.65-.72,1,.55-1.11,1.08-2.22,1.6-3.34.7-1.54,1.42-3.07,2-4.65a0,0,0,0,0-.09,0c-1.54,2.53-2.88,5.19-4.23,7.82s-2.67,5.37-4,8.07c-.36.75-.7,1.51-1,2.27a19.93,19.93,0,0,0-.93,2.24c0,.05.06.09.09.05a32.58,32.58,0,0,0,2.12-3.73c.7-1.31,1.36-2.64,2-4s1.25-2.45,1.86-3.69a18,18,0,0,0,1.5-1.89,20.85,20.85,0,0,0,1.48-2.44A.05.05,0,0,0,166.35,187.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.45,191.81l-4.95,9.54-2.43,4.78q-.62,1.2-1.17,2.4a6.85,6.85,0,0,0-.46,1.17s0,0,0,0-.07-.15-.05-.12l0,0,.1.08.23.19.53.41,8.6,6.43c2.85,2.16,5.7,4.34,8.51,6.56l0,0,0,0-.59,1,.5-1.06v.07q-4.45-3-8.82-6.13c-2.9-2.11-5.82-4.18-8.65-6.4l-.53-.42-.28-.24-.15-.13,0,0a.49.49,0,0,1-.08-.2,1.16,1.16,0,0,1,0-.19,7.52,7.52,0,0,1,.53-1.33c.39-.82.79-1.61,1.21-2.41.82-1.59,1.7-3.16,2.57-4.73Q160.68,196.41,163.45,191.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,179.23c-2.79.29-8.91-4.6-11.44-8.87-.17-.3.19-3.46.43-7.32.14-2.34.25-5,.17-7.35l15.11,3.15a38.44,38.44,0,0,0-1.14,9.23,4.93,4.93,0,0,0,.14,1c0,.05,0,.1,0,.17C182.19,171.06,182.9,178.77,178.53,179.23Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.79,169.05a.57.57,0,0,1,0,.16,10.18,10.18,0,0,1-1.54.13c-8.53.09-11-10.23-11.5-13.42l14,2.91a38.33,38.33,0,0,0-1.15,9.24A6.25,6.25,0,0,0,181.79,169.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.74,136.85c-1.72,5.29.79,20.71,4.51,24.21,5.39,5.07,14.36,5.72,18.71-.8,4.21-6.31.57-26.35-3.59-29.54C179.23,126,168.29,129,165.74,136.85Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.38,145.93s-.07.06-.06.11c.22,1.07.3,2.34-.62,2.87,0,0,0,.07,0,.05C178.88,148.59,178.77,146.91,178.38,145.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.22,145c-1.76.17-1.28,3.68.35,3.52S178.7,144.83,177.22,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.64,145s.1,0,.1.08c.11,1.09.42,2.32,1.45,2.55a0,0,0,1,1,0,.06C185,147.69,184.57,146.06,184.64,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,143.74c1.73-.37,2.34,3.12.74,3.46S184,144.05,185.46,143.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.65,143.62a12,12,0,0,0,1.24-.63,2.2,2.2,0,0,0,1.15-.88.74.74,0,0,0-.23-.85,1.79,1.79,0,0,0-1.8.05,2.6,2.6,0,0,0-1.35,1.32A.76.76,0,0,0,175.65,143.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.57,142.26c-.48,0-.91-.11-1.38-.17a2.26,2.26,0,0,1-1.38-.45.71.71,0,0,1-.08-.87,1.8,1.8,0,0,1,1.72-.56,2.55,2.55,0,0,1,1.71.78A.76.76,0,0,1,186.57,142.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.62,155.66c.28.21.58.51,1,.49a2.59,2.59,0,0,0,1.09-.41s.07,0,.05,0a1.42,1.42,0,0,1-1.25.74,1.12,1.12,0,0,1-.94-.81C178.5,155.66,178.58,155.62,178.62,155.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.31,152.39a3.59,3.59,0,0,0,2.58,1.27,4.62,4.62,0,0,0,1.28-.11.84.84,0,0,0,.24-.06l.23-.07a.26.26,0,0,0,.18-.26h0a.54.54,0,0,0,0-.1h0V153c-.09-.81-.32-2-.32-2,.31.11,1.89.59,1.81.17a54.16,54.16,0,0,0-2.78-10.57c0-.11-.22-.06-.19.05.5,3.34,1.59,6.57,2.16,9.91a6.39,6.39,0,0,0-1.75-.29c-.11.05.51,2.34.51,2.7a0,0,0,0,1,0,0,5,5,0,0,1-3.83-.66C179.31,152.23,179.24,152.31,179.31,152.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.65,153.2a4.24,4.24,0,0,1-1.52,1.53A1.91,1.91,0,0,1,180,155c-.86-.11-1-.88-.92-1.55a5.17,5.17,0,0,1,.24-1A5.51,5.51,0,0,0,182.65,153.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.13,154.73A1.91,1.91,0,0,1,180,155c-.86-.11-1-.88-.92-1.55A2,2,0,0,1,181.13,154.73Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.23,149.79s-5-9-4.27-14.07c.31-2.29,3.51-3.71,3.51-3.71a5.21,5.21,0,0,1,1.85-5.16c2.82-2.45,9.38-1.61,9.38-1.61s4.51-6,10.45-3.3,1.73,9.37,1.73,9.37,2.09,3.23-3.42,5.47-16-.61-16-.61a37.39,37.39,0,0,1-.62,11.15A3.41,3.41,0,0,1,165.23,149.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.74,125.36a10.56,10.56,0,0,0-4.22-.94,11.41,11.41,0,0,0-3.85.44,6.37,6.37,0,0,0-4.66,4.59,4.43,4.43,0,0,0,.71,3.37s.09,0,.06,0c-1.33-1.78-.48-4.44,1-5.83a9.59,9.59,0,0,1,6.46-2.1,18.89,18.89,0,0,1,4.43.65A.07.07,0,0,0,176.74,125.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.35,125a5.16,5.16,0,0,0-3.44-3.44,8.76,8.76,0,0,0-5.72,0,11,11,0,0,0-4.82,3.27s0,.08.06,0a9.75,9.75,0,0,1,9.47-3.09,4.77,4.77,0,0,1,3.44,7.27,9.93,9.93,0,0,1-4,3.73,0,0,0,1,0,0,.06,10.25,10.25,0,0,0,4-3.14A5.81,5.81,0,0,0,190.35,125Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.75,137.12a18.2,18.2,0,0,1-7.64,1,37,37,0,0,1-7.94-1.42c-1.51-.43-3-.91-4.49-1.43a0,0,0,0,0,0,.08,40.62,40.62,0,0,0,8.08,2.85,20.55,20.55,0,0,0,7.89.25,17.44,17.44,0,0,0,4.16-1.29S185.79,137.11,185.75,137.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.79,149.44s-3.48-5-5.74-3.72.37,8.44,3,9.42a2.68,2.68,0,0,0,3.6-1.45Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.86,147.76c-.05,0-.06.06,0,.07,1.86.75,2.84,2.47,3.52,4.26a1.48,1.48,0,0,0-2.22-.41s0,.11.05.1a1.65,1.65,0,0,1,1.82.58,7.53,7.53,0,0,1,.88,1.47c.09.17.38.08.32-.11v-.05C168.24,151.31,166.4,148,163.86,147.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.86,171.89s-.05,0-.05,0c.38,2.79,1.06,9.26-4,9.29a11.23,11.23,0,0,1-5.6-1.9,25.71,25.71,0,0,1-4.54-3.42,35.31,35.31,0,0,1-4.31-4.52c-.05-.07-.18,0-.12.09a59.5,59.5,0,0,0,3.92,4.8A22.94,22.94,0,0,0,174,180a11.46,11.46,0,0,0,5.95,1.81,4.16,4.16,0,0,0,4-3A13.71,13.71,0,0,0,183.86,171.89Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-210"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.37 394.68 281.08 400.54 278.88 444.39 273.29 444.39 271.09 400.54 270.8 394.68 281.37 394.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.8 394.68 281.37 394.68 281.08 400.54 271.09 400.54 270.8 394.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.82 394.68 312.53 400.54 310.33 444.39 304.73 444.39 302.54 400.54 302.24 394.68 312.82 394.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.24 394.68 312.82 394.68 312.53 400.54 302.54 400.54 302.24 394.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.52 394.68 376.23 400.54 374.04 444.39 368.44 444.39 366.24 400.54 365.95 394.68 376.52 394.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.95 394.68 376.52 394.68 376.23 400.54 366.24 400.54 365.95 394.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.97 394.68 407.68 400.54 405.48 444.39 399.89 444.39 397.69 400.54 397.4 394.68 407.97 394.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.4 394.68 407.97 394.68 407.68 400.54 397.69 400.54 397.4 394.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.44,
    y: 381.1,
    width: 151.89,
    height: 13.57,
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicType);
export default __webpack_public_path__ + "static/media/music-type.c92c881cd56a3c01e836e994ed4d322c.svg";
export { ForwardRef as ReactComponent };